<template>
	<!-- 第五区代码 -->
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="店铺名称" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.storeName" placeholder="请输入店铺名称"></el-input>
					</el-form-item>
					<el-form-item label="商品名称" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.goodsName" placeholder="请输入商品名称"></el-input>
					</el-form-item>
					<el-form-item label="商品编号" class='tiny' cleartable> 
						<!--  -->
						<el-input style="width: 200px;" v-model="searchInfo.goodsCode" placeholder="请输入商品编号"></el-input>
					</el-form-item>
					<el-form-item label="审核状态" class='tiny' cleartable>
						<el-select v-model="searchInfo.authStatus" placeholder="请选择">
							<el-option key="-1" label="全部" value="">全部</el-option>

							<el-option key="0" label="待审核" :value="0">待审核</el-option>
							<el-option key="1" label="通 过" :value="1">通 过</el-option>
							<el-option key="2" label="驳 回" :value="2">驳 回</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="商品状态" class='tiny' cleartable>
						<el-select v-model="searchInfo.status" placeholder="请选择">
							<el-option key="-1" label="全部" value="">全部</el-option>

							<el-option key="0" label="下架" :value="0">下架</el-option>
							<el-option key="1" label="上架" :value="1">上架</el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="显示位置" class='tiny' cleartable>
						<el-select v-model="searchInfo.goodsType" placeholder="请选择">
							<el-option key="-1" label="全部" :value="null">全部</el-option>

							<el-option key="1" label="商城" :value="1"></el-option>
							<el-option key="2" label="门店" :value="2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="仅内部记账" class='tiny' cleartable>
						<el-select v-model="searchInfo.isShowOnline" placeholder="请选择">
							<el-option key="-1" label="全部" :value="null">全部</el-option>

							<el-option key="1" label="会员端展示" :value="0"></el-option>
							<el-option key="2" label="仅内部展示" :value="1"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="商品分类" class='tiny' cleartable>
						<el-select v-model="searchInfo.isShopFil" placeholder="请选择">
							<el-option key="-1" label="全部" value="">全部</el-option>

							<el-option key="1" label="兑换商品" :value="14"></el-option>
							<el-option key="2" label="共享商品" :value="16"></el-option>
							<el-option key="3" label="活动商品" :value="17"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="排序方式" class='tiny' cleartable>
						<el-select v-model="searchInfo.orderType" placeholder="默认修改时间降序">
							<el-option key="0" label="修改时间升序" :value="0"></el-option>
							<el-option key="3" label="创建时间降序" :value="3"></el-option>
							<el-option key="4" label="创建时间升序" :value="4"></el-option>
							<el-option key="1" label="排序等级降序" :value="1"></el-option>
							<el-option key="2" label="排序等级升序" :value="2"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
							<el-button type="primary" @click="dialogVisibleFun()" v-if="stoId != 0">新增商品
							</el-button>
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>


		<el-table :data="goodsList.list" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="loading"
			element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" >

			<el-table-column type="expand">
				<template slot-scope="props">
					<el-form label-position="left" inline class="demo-table-expand" label-width="150px">
						<el-form-item label="用户ID">
							<span>{{ props.row.userId?props.row.userId:'无' }}</span>
						</el-form-item>
						<el-form-item label="用户名">
							<span>{{ props.row.username?props.row.username:'无' }}</span>
						</el-form-item>
						<!-- <el-form-item label="供应商ID">
							<span>{{ props.row.storeId }}</span>
						</el-form-item> -->
						<el-form-item label="供应商名称">
							<span>{{ props.row.supplierName }}</span>
						</el-form-item>
						<el-form-item label="店铺名称">
							<span v-if="props.row.storeId!=0">{{ props.row.storeName }}</span>
							<span v-else>自营</span>
						</el-form-item>
						<el-form-item label="仅内部记账商品">
							<span v-if="props.row.isShowOnline"> 仅内部展示 </span>
							<span v-else> 会员端展示 </span>
						</el-form-item>
						<el-form-item label="商品ID">
							<span>{{ props.row.id }}</span>
						</el-form-item>
						<el-form-item label="商品名称">
							<span>{{ props.row.goodsName }}</span>
						</el-form-item>
						<el-form-item label="商品编号">
							<span>{{ props.row.goodsCode?props.row.goodsCode:'无' }}</span>
						</el-form-item>
						<el-form-item label="分类名称">
							<span>{{ props.row.className ?
								props.row.classNameOne+'/'+props.row.classNameTwo+'/'+props.row.className:'无' }}</span>
						</el-form-item>
						<el-form-item label="市场价">
							<span>￥{{ props.row.marketPrice }}</span>
						</el-form-item>
						<!-- <el-form-item label="赠送积分">
							<span>{{ props.row.marketPrice }}</span>
						</el-form-item> -->
						<el-form-item label="零售价">
							<span>￥{{ props.row.price }}</span>
						</el-form-item>
						<el-form-item label="供货价">
							<span>￥{{ props.row.costPrice }}</span>
						</el-form-item>
						<el-form-item label="取货方式" v-if="props.row.goodsType == 2">
							<p v-if="props.row.expressType == 1">到店核销</p>
						</el-form-item>
						<div v-if="props.row.goodsType == 1">
							<el-form-item label="商品分类">
								<span v-if="props.row.isShopFil == 14">兑换商品</span>
								<span v-if="props.row.isShopFil == 16">共享商品</span>
								<span v-if="props.row.isShopFil == 17">活动商品</span>
							</el-form-item>
							<el-form-item label="是否为云链选品" v-if="stoId == 0">
								<span v-if="props.row.isCloud">是</span>
								<span v-else>否</span>
							</el-form-item>
							<el-form-item label="分销价" v-if="stoId == 0">
								<span>￥{{ props.row.agreementPrice || 0 }}</span>
							</el-form-item>
							<el-form-item label="运费">
								<span>￥{{ props.row.freightPrice }}</span>
							</el-form-item>
							<el-form-item label="是否可采购下单" v-if="stoId == 0">
								<span v-if="props.row.openS2b">可以</span>
								<span v-else>不可以</span>
							</el-form-item>
							<el-form-item label="是否是活动区" v-if="stoId == 0">
								<span v-if="props.row.isActivityArea">是</span>
								<span v-else>否</span>
							</el-form-item>
							<el-form-item label="起采数量" v-if="stoId == 0">
								<span>{{ props.row.minCaigouNum}}</span>
							</el-form-item>
						</div>
						<el-form-item label="排序级别">
							<span>{{ props.row.orderIndex }}</span>
						</el-form-item>
						<el-form-item label="商品简单描述">
							<span>{{ props.row.remark?props.row.remark:'无' }}</span>
						</el-form-item>
						<el-form-item v-if="props.row.authStatus == 2" label="驳回原因">
							<span>{{ props.row.rejected }}</span>
						</el-form-item>
						<el-form-item label="商品详细描述">
							<el-button size="small" type="text" @click="findDetail(props.row.detail,1)">点击查看</el-button>
						</el-form-item>
						<el-form-item label="商品图片">
							<el-button size="small" type="text" @click="findDetail(props.row.images,2)">点击查看</el-button>
						</el-form-item>
					</el-form>
				</template>
			</el-table-column>

			<el-table-column prop="id" label="商品ID" align="center" :show-overflow-tooltip="true" min-width="80">
			</el-table-column>
			<el-table-column prop="goodsName" label="商品名称" align="center" :show-overflow-tooltip="true" min-width="120">
			</el-table-column>
			<el-table-column prop="storeName" label="店铺名称" align="center" :show-overflow-tooltip="true" min-width="120">
			</el-table-column>
			<el-table-column prop="status" label="商品状态" align="center" :show-overflow-tooltip="true" min-width="80">
				<template slot-scope="scope">
					<p v-if="scope.row.status==0">下架</p>
					<p v-if="scope.row.status==1">上架</p>
				</template>
			</el-table-column>
			<el-table-column prop="className" label="所属类别" align="center" :show-overflow-tooltip="true" min-width="80">
				<template slot-scope="scope">
					<p>{{scope.row.className}}
					</p>
				</template>
			</el-table-column>
			<el-table-column prop="goodsType" label="显示位置" align="center" :show-overflow-tooltip="true" width="80">
				<template slot-scope="scope">
					<p v-if="scope.row.goodsType==0"> 云连锁 </p>
					<p v-if="scope.row.goodsType==1"> 商城 </p>
					<p v-if="scope.row.goodsType==2"> 门店 </p>
				</template>
			</el-table-column>
			<el-table-column prop="stock" label="库存" align="center" :show-overflow-tooltip="true" min-width="80">
			</el-table-column>
			<el-table-column prop="salesSum" label="销量" align="center" :show-overflow-tooltip="true" min-width="80">
			</el-table-column>
			<el-table-column prop="costPrice" label="供应价" align="center" :show-overflow-tooltip="true" min-width="80">
			</el-table-column>
			<el-table-column prop="price" label="零售价" align="center" :show-overflow-tooltip="true" min-width="80">
			</el-table-column>
			<el-table-column prop="marketPrice" label="市场价" align="center" :show-overflow-tooltip="true" min-width="80">
			</el-table-column>
			<!-- <el-table-column prop="marketPrice" label="赠送积分" align="center" :show-overflow-tooltip="true">
			</el-table-column> -->
			<el-table-column prop="authStatus" label="审核状态" align="center" :show-overflow-tooltip="true" width="80">
				<template slot-scope="scope">
					<!-- <p v-if="scope.row.authStatus==0">待审核</p>
					<p v-if="scope.row.authStatus==1">通 过</p>
					<p v-if="scope.row.authStatus==2">驳 回</p> -->
					<p v-if="scope.row.authStatus==0" style="color:#E6A23C;font-weight: bold;">待审核</p>
					<p v-if="scope.row.authStatus==1" style="color:#67C23A;font-weight: bold;">通 过</p>
					<p v-if="scope.row.authStatus==2" style="color:#F56C6C;font-weight: bold;">驳 回</p>
				</template>
			</el-table-column>
			<el-table-column prop="createTime" label="创建时间" sortable align="center" :show-overflow-tooltip="true"
				min-width="120"> </el-table-column>
			<el-table-column prop="updateTime" label="更新时间" sortable align="center" :show-overflow-tooltip="true"
				min-width="120"> </el-table-column>

			<el-table-column  label="操作"  fixed="right" align="center" width="160">
				<template slot-scope="scope">
					<el-button v-if="scope.row.authStatus==0 && isRecheck" size="small" type="text" @click="editialogVisible(scope.row.id)">
						审核</el-button>

					<el-button  size="small" type="text" @click="dialogVisibleFun(scope.row.id)">编辑
					</el-button>
					　　　　
					<el-dropdown trigger="click" style="margin-left: 10px;">
						<el-button type="text" size="small">更多</el-button>
						<el-icon class="el-icon-caret-bottom"></el-icon>
						<el-dropdown-menu slot="dropdown">
							<!-- <el-dropdown-item
								@click.native="setUpBuy(scope.row.id,scope.row.goodsName,scope.row.storeId,scope.row.images)">设为拼团商品
							</el-dropdown-item> -->
							<el-dropdown-item @click.native="storeGoodsJobSharing(scope.row)"
								v-if="scope.row.goodsType==2">岗位分成</el-dropdown-item>	
							<el-dropdown-item @click.native="storeGoodsHitTheShelfOrSoldOut(scope.row.id)"
								v-if="scope.row.status==0 && scope.row.authStatus==1">上架</el-dropdown-item>

							<el-dropdown-item @click.native="storeGoodsHitTheShelfOrSoldOut(scope.row.id)"
								v-if="scope.row.status==1 && scope.row.authStatus==1">下架</el-dropdown-item>
							
							<el-dropdown-item @click.native="toDelete(scope.row)">删除</el-dropdown-item>

							<el-dropdown-item @click.native="auditClick(scope.row)">审核记录</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
					　　　　
				</template>
				　　
			</el-table-column>
		</el-table>
		<el-pagination style="margin: 20px 0px 20px;" background :current-page="goodsList.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="goodsList.total"
			@size-change="handleSizeChange">
		</el-pagination>

		<el-dialog style="float:rigin" title="商品审核" :closeOnClickModal="false" :visible.sync="editDialogVisible"
			width="80%">
			<div class="app-container" style="text-align: center;display: flex;width: 100%;justify-content: space-between;">
				<div style="width:48%">
					<el-form size="medium" v-if="auditGoodsInfo">
						<div style="width: 100%;text-align: center;font-size: 22px;padding: 10px;">原信息</div>
						<div>
							<el-form-item label="店铺名称" >
								<el-input type="text" v-model="auditGoodsInfo.storeName" placeholder="请输入" disabled />
							</el-form-item>
							<el-form-item  label="供应商名称">
								<el-input type="text" v-model="auditGoodsInfo.supplierName" placeholder="请输入" disabled />
							</el-form-item>
						</div>
						<div>
							<el-form-item label="商品名称" style="width: 100%;">
								<el-input type="text" disabled clearable v-model="auditGoodsInfo.goodsName"
									placeholder="请输入商品名称" />
							</el-form-item>
							<el-form-item label="商品编号" style="width: 100%;">
								<el-input type="text" disabled clearable v-model="auditGoodsInfo.goodsCode"
									placeholder="请输入商品编号" />
							</el-form-item>
						</div>
						<div style="display: flex;align-items: center;">
							<el-form-item :label-width="formLabelWidth" label="市场价" >
								<el-input type="text" disabled size="small" width="50"
									v-model="auditGoodsInfo.marketPrice" placeholder="请输入数字" />
							</el-form-item>
							<el-form-item :label-width="formLabelWidth" label="零售价格" >
								<el-input type="text" disabled size="small" width="50"
									v-model="auditGoodsInfo.price" placeholder="请输入数字" />
							</el-form-item>
							<el-form-item :label-width="formLabelWidth" label="供货价格" >
								<el-input type="text" disabled size="small" width="50"
									v-model="auditGoodsInfo.costPrice" placeholder="请输入数字" />
							</el-form-item>
						</div>
						
						
						<div style="display: flex;align-items: center;justify-content: flex-start;">
							<el-form-item label="排序级别" class="redItem" >
								<span>{{auditGoodsInfo.orderIndex}}</span>
							</el-form-item>
							<el-form-item label="销量" class="redItem" style="margin-left: 30px;">
								<span>{{auditGoodsInfo.salesSum}}</span>
							</el-form-item>
							
							<el-form-item label="库存" class="redItem" style="margin-left: 30px;">
								<span>{{auditGoodsInfo.stock}}</span>
							</el-form-item>
						</div>

						<div v-if="auditGoodsInfo.goodsType == 1">
							<!-- 商城商品 -->
							<div style="display: flex;align-items: center;justify-content: space-between;">
								<el-form-item label="分类">
									<span>{{ auditGoodsInfo.className ?
									auditGoodsInfo.classNameOne+'/'+auditGoodsInfo.classNameTwo+'/'+auditGoodsInfo.className:'无' }}</span>

								</el-form-item>
								
							</div>
							
							
							<div style="display: flex;align-items: center;">
								<el-form-item label="发货方式" :label-width="formLabelWidth">
									<el-select disabled v-model="auditGoodsInfo.expressType" placeholder="请选择发货方式"
										style="width:200px;margin-right:10px;">
										<el-option clearable label="快递" :value="1"></el-option>
										<el-option clearable label="自提" :value="2"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item :label-width="formLabelWidth" label="商品类别" >
									<el-select disabled v-model="auditGoodsInfo.isShopFil" placeholder="请选择商品类别"
										style="width:200px;margin-right:10px;">
										<el-option clearable label="兑换" :value="14"></el-option>
										<el-option clearable label="共享" :value="16"></el-option>
										<el-option clearable label="活动" :value="17"></el-option>
									</el-select>
								</el-form-item>
							</div>
							<div style="display: flex;align-items: center;justify-content: space-between;">
								<el-form-item :label-width="formLabelWidth" label="是否上架" >
									<el-switch v-model="auditGoodsInfo.status" :active-value="true" :inactive-value="false" disabled>
									</el-switch>
								</el-form-item>
								<el-form-item label-width="300px" label="是否为活动区产品" >
									<el-switch v-model="auditGoodsInfo.isActivity" :active-value="true" :inactive-value="false" disabled>
									</el-switch>
								</el-form-item>
								<el-form-item :label-width="formLabelWidth" label="储备积分" v-if="auditGoodsInfo.isActivity">
									<el-input type="text" disabled size="small" width="50"
									v-model="auditGoodsInfo.reservePoints" placeholder="请输入数字" />
								</el-form-item>
							</div>
							

							<div style="display: flex;align-items: center;justify-content: space-between;">
								<el-form-item label-width="300px" label="是否为云链选品" >
									<el-switch v-model="auditGoodsInfo.isCloud" :active-value="true" :inactive-value="false" disabled>
									</el-switch>
								</el-form-item>
								<el-form-item :label-width="formLabelWidth" label="分销价" v-if="auditGoodsInfo.isCloud">
									<el-input type="text" disabled size="small" width="50"
									v-model="auditGoodsInfo.agreementPrice" placeholder="请输入数字" />
								</el-form-item>
							</div>
							<div style="display: flex;align-items: center;justify-content: space-between;">
								<el-form-item label-width="300px" label="是否可采购下单" >
									<span v-if="auditGoodsInfo.openS2b">可以</span>
									<span v-else>不可以</span>
								</el-form-item>
								<el-form-item :label-width="formLabelWidth" label="起采数量" v-if="auditGoodsInfo.openS2b">
									<span>{{ auditGoodsInfo.minCaigouNum }}</span>
								</el-form-item>
							</div>
							<div style="display: flex;align-items: center;justify-content: space-between;">
								<el-form-item label-width="300px" label="活动区产品" >
									<span v-if="auditGoodsInfo.isActivityArea">是</span>
									<span v-else>否</span>
								</el-form-item>
								<el-form-item :label-width="formLabelWidth" label="活动区赠送倍数" v-if="auditGoodsInfo.isActivityArea">
									<span>{{ auditGoodsInfo.activityAreaMultiple }}</span>
								</el-form-item>
							</div>
							
						</div>
						
						<div v-if="auditGoodsInfo.goodsType == 2">
							<div style="display: flex;align-items: center;">
								<el-form-item label="取货方式" :label-width="formLabelWidth">
									<el-select disabled v-model="auditGoodsInfo.expressType" placeholder="请选择取货方式"
										style="width:200px;margin-right:10px;">
										<el-option clearable label="到店核销" :value="1"></el-option>
									
									</el-select>
								</el-form-item>
								
							</div>
							<div style="display: flex;align-items: center;justify-content: space-between;">
								<el-form-item :label-width="formLabelWidth" label="是否上架" >
									<el-switch v-model="auditGoodsInfo.status" :active-value="true" :inactive-value="false" disabled>
									</el-switch>
								</el-form-item>
								<el-form-item label-width="300px" label="是否为活动区产品" >
									<el-switch v-model="auditGoodsInfo.isActivity" :active-value="true" :inactive-value="false" disabled>
									</el-switch>
								</el-form-item>
								<el-form-item :label-width="formLabelWidth" label="储备积分" v-if="auditGoodsInfo.isActivity">
									<el-input type="text" disabled size="small" width="50"
									v-model="auditGoodsInfo.reservePoints" placeholder="请输入数字" />
								</el-form-item>
							</div>
						</div>
						
						<div style="display: flex;align-items: center;justify-content: space-between;
						flex-wrap:wrap">
							<el-form-item label="商品图片(1:1)" >
								<br />
								<div style="width: 100%;display: flex;align-items: initial;flex-wrap:wrap">
									<img v-for="(it,index) in fileList" :src="it.url" :key="index" @click="handlePictureCardPreview(it)"
									style="width:144px;height:144px;margin-right:10px;margin-bottom:10px">
								</div>
							</el-form-item>
						</div>
						<el-form-item label="商品详细描述">
							<el-button size="small" type="text" @click="findDetail(auditGoodsInfo.detail,1)">点击查看</el-button>
						</el-form-item>
						
					</el-form>
				</div>

				<div style="width:48%">
					<el-form size="medium">
						<div style="width: 100%;text-align: center;font-size: 22px;padding: 10px;">修改后信息</div>
						<div>
							<el-form-item  label="店铺名称">
								<el-input type="text" v-model="auditGoodsInfoTwo.storeName" placeholder="请输入" disabled />
							</el-form-item>
							<el-form-item  label="供应商名称">
								<el-input type="text" v-model="auditGoodsInfoTwo.supplierName" placeholder="请输入" disabled />
							</el-form-item>
						</div>
						<div>
							<el-form-item label="商品名称" style="width: 100%;">
								<el-input type="text" disabled clearable v-model="auditGoodsInfoTwo.goodsName"
									placeholder="请输入商品名称" />
							</el-form-item>
							<el-form-item label="商品编号" style="width: 100%;">
								<el-input type="text" disabled clearable v-model="auditGoodsInfoTwo.goodsCode"
									placeholder="请输入商品编号" />
							</el-form-item>
						</div>
						
						<div style="display: flex;align-items: center;">
							<el-form-item :label-width="formLabelWidth" label="市场价" >
								<el-input type="text" disabled size="small" width="50"
									v-model="auditGoodsInfoTwo.marketPrice" placeholder="请输入数字" />
							</el-form-item>
							<el-form-item :label-width="formLabelWidth" label="零售价格" >
								<el-input type="text" disabled size="small" width="50"
									v-model="auditGoodsInfoTwo.price" placeholder="请输入数字" />
							</el-form-item>
							<el-form-item :label-width="formLabelWidth" label="供货价格" >
								<el-input type="text" disabled size="small" width="50"
									v-model="auditGoodsInfoTwo.costPrice" placeholder="请输入数字" />
							</el-form-item>
						</div>

						
						<div style="display: flex;align-items: center;justify-content: flex-start;">
							<el-form-item label="排序级别" class="redItem" >
								<span>{{auditGoodsInfoTwo.orderIndex}}</span>
							</el-form-item>
							<el-form-item label="销量" class="redItem"  style="margin-left: 30px;">
								<span>{{auditGoodsInfoTwo.salesSum}}</span>
							</el-form-item>
							
							<el-form-item label="库存" class="redItem" style="margin-left: 30px;">
								<span>{{auditGoodsInfoTwo.stock}}</span>
							</el-form-item>
						</div>
						
						
						<div v-if="auditGoodsInfoTwo.goodsType == 1">
							<!-- 商城商品 -->
							<div style="display: flex;align-items: center;justify-content: space-between;">
								<el-form-item label="分类">
									<span>{{ auditGoodsInfoTwo.className ?
									auditGoodsInfoTwo.classNameOne+'/'+auditGoodsInfoTwo.classNameTwo+'/'+auditGoodsInfoTwo.className:'无' }}</span>

								</el-form-item>
								
							</div>
							
							
							<div style="display: flex;align-items: center;">
								<el-form-item label="发货方式" :label-width="formLabelWidth">
									<el-select disabled v-model="auditGoodsInfoTwo.expressType" placeholder="请选择发货方式"
										style="width:200px;margin-right:10px;">
										<el-option clearable label="快递" :value="1"></el-option>
										<el-option clearable label="自提" :value="2"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item :label-width="formLabelWidth" label="商品类别" >
									<el-select disabled v-model="auditGoodsInfoTwo.isShopFil" placeholder="请选择商品类别"
										style="width:200px;margin-right:10px;">
										<el-option clearable label="兑换" :value="14"></el-option>
										<el-option clearable label="共享" :value="16"></el-option>
										<el-option clearable label="活动" :value="17"></el-option>
									</el-select>
								</el-form-item>
							</div>
							<div style="display: flex;align-items: center;justify-content: space-between;">
								<el-form-item :label-width="formLabelWidth" label="是否上架" >
									<el-switch v-model="auditGoodsInfoTwo.status" :active-value="true" :inactive-value="false" disabled>
									</el-switch>
								</el-form-item>
								<el-form-item label-width="300px" label="是否为活动区产品" >
									<el-switch v-model="auditGoodsInfoTwo.isActivity" :active-value="true" :inactive-value="false" disabled>
									</el-switch>
								</el-form-item>
								<el-form-item :label-width="formLabelWidth" label="储备积分" v-if="auditGoodsInfoTwo.isActivity">
									<el-input type="text" disabled size="small" width="50"
									v-model="auditGoodsInfoTwo.reservePoints" placeholder="请输入数字" />
								</el-form-item>
							</div>
							<div style="display: flex;align-items: center;justify-content: space-between;">
								<el-form-item label-width="300px" label="是否为云链选品" >
									<el-switch v-model="auditGoodsInfoTwo.isCloud" :active-value="true" :inactive-value="false" disabled>
									</el-switch>
								</el-form-item>
								<el-form-item :label-width="formLabelWidth" label="分销价" v-if="auditGoodsInfoTwo.isCloud">
									<el-input type="text" disabled size="small" width="50"
									v-model="auditGoodsInfoTwo.agreementPrice" placeholder="请输入数字" />
								</el-form-item>
							</div>
							<div style="display: flex;align-items: center;justify-content: space-between;">
								<el-form-item label-width="300px" label="是否可采购下单" >
									<span v-if="auditGoodsInfoTwo.openS2b">可以</span>
									<span v-else>不可以</span>
								</el-form-item>
								<el-form-item :label-width="formLabelWidth" label="起采数量" v-if="auditGoodsInfoTwo.openS2b">
									<span>{{ auditGoodsInfoTwo.minCaigouNum }}</span>
								</el-form-item>
							</div>
							<div style="display: flex;align-items: center;justify-content: space-between;">
								<el-form-item label-width="300px" label="活动区产品" >
									<span v-if="auditGoodsInfoTwo.isActivityArea">是</span>
									<span v-else>否</span>
								</el-form-item>
								<el-form-item label-width="200" label="活动区赠送倍数" v-if="auditGoodsInfoTwo.isActivityArea">
									<span>{{ auditGoodsInfoTwo.activityAreaMultiple }}</span>
								</el-form-item>
							</div>
						</div>
						
						<div v-if="auditGoodsInfoTwo.goodsType == 2">
							<div style="display: flex;align-items: center;">
								<el-form-item label="取货方式" :label-width="formLabelWidth">
									<el-select disabled v-model="auditGoodsInfoTwo.expressType" placeholder="请选择取货方式"
										style="width:200px;margin-right:10px;">
										<el-option clearable label="到店核销" :value="1"></el-option>
									
									</el-select>
								</el-form-item>
								
							</div>
							<div style="display: flex;align-items: center;justify-content: space-between;">
								<el-form-item :label-width="formLabelWidth" label="是否上架" >
									<el-switch v-model="auditGoodsInfoTwo.status" :active-value="true" :inactive-value="false" disabled>
									</el-switch>
								</el-form-item>
								<el-form-item label-width="300px" label="是否为活动区产品" >
									<el-switch v-model="auditGoodsInfoTwo.isActivity" :active-value="true" :inactive-value="false" disabled>
									</el-switch>
								</el-form-item>
								<el-form-item :label-width="formLabelWidth" label="储备积分" v-if="auditGoodsInfoTwo.isActivity">
									<el-input type="text" disabled size="small" width="50"
									v-model="auditGoodsInfoTwo.reservePoints" placeholder="请输入数字" />
								</el-form-item>
							</div>
						</div>

						
						
						
						<div style="display: flex;align-items: center;justify-content: space-between;flex-wrap:wrap">
							<el-form-item label="商品图片(1:1)" >
								<br />
								<div style="width: 100%;display: flex;align-items: initial;flex-wrap:wrap">
									<img v-for="(it,index) in fileList1" :src="it.url" :key="index" @click="handlePictureCardPreview(it)"
									style="width:144px;height:144px;margin-right:10px;margin-bottom:10px">
								</div>
								
							</el-form-item>
						</div>
						<el-form-item label="商品详细描述">
							<el-button size="small" type="text" @click="findDetail(auditGoodsInfoTwo.detail,1)">点击查看</el-button>
						</el-form-item>
					</el-form>
				</div>
				
			</div>
			<div style="text-align: center;">
				<el-button @click="bohui">驳 回</el-button>
				<el-button @click="editStoreInfoCheck(1)" :loading="loadingTG" type="primary">通 过</el-button>

			</div>
		</el-dialog>

		<!-- 审核驳回 -->
		<el-dialog style="float:rigin" title="审核驳回" :closeOnClickModal="false" :visible.sync="editDialogVisible1"
			width="30%">
			<div style="display: flex;align-items: center;justify-content: space-between;">
				<el-form>
					<el-form-item label="驳回原因:" class="redItem" style="width: 100%;">
						<el-input style="width: 100%;" v-model="reason" placeholder="请输入驳回原因">
						</el-input>
					</el-form-item>
				</el-form>
			</div>
			<div style="text-align: center;">
				<el-button @click="editDialogVisible1=false; loading=false">取 消</el-button>
				<el-button @click="editStoreInfoCheck(2)" :loading="loadingBH" type="primary">确 定</el-button>
			</div>
		</el-dialog>

		<!-- 详情查看 -->
		<el-dialog style="float:rigin" title="详情查看" :closeOnClickModal="false" :visible.sync="dialogVisibleDetails"
			width="50%">
			<div style="max-height:700px;overflow-y:scroll; overflow-x:hidden;">
				<div class="detailImg" v-if="detailType == 1" v-html="detail"></div>
				<div v-if="detailType == 2"
					style="display: flex;align-items: center;justify-content: space-between;flex-wrap: wrap;">
					<img style="width:40%;margin: 20px;" :src="image" v-for="(image,index) in  images" :key="index" />
				</div>
			</div>
			<div style="text-align: center;margin-top:50px">
				<el-button type="primary" @click="dialogVisibleDetails = false">关 闭</el-button>
			</div>
		</el-dialog>

	

		<!-- 新增、编辑商品 -->
		<el-dialog style="float:rigin" :title="dialogVisibleFunName" :closeOnClickModal="false"
			:visible.sync="dialogVisible" width="1050px">
			<div class="app-container" style="text-align: center;">
				<el-form size="medium">
					<div v-if="dialogVisibleFunName == '新增商品'">
						<div style="display: flex;align-items: center;">
							<el-form-item label="选择店铺" v-if="stoId == 0" style="width:615px;">
								<el-select v-model="storeGoodsInfo.storeId" filterable 
								:remote-method="remoteMethod"
								:loading="storeLoading"
								remote
								reserve-keyword
								class="big" placeholder="请选择"
									@change="getStoreName">
									<el-option v-for="item in selectStoreName" :key="item.id" :value="item.id"
										:label="item.storeName">
									</el-option> 
								</el-select>
							</el-form-item> 
							<el-form-item label="供应商名称" cleartable  :label-width="formLabelWidth" style="width:310px;">
								<el-select v-model="storeSupplierId" placeholder="请选择" @change="getSupplier">
									<el-option v-for="item in accountList" :key="item.id" :value="item.id"
										:label="item.supplierName">
									</el-option>
								</el-select>
							</el-form-item>
						</div>
					</div>

					<div style="display: flex;align-items: center;"
						v-if="dialogVisibleFunName != '新增商品'">
						<el-form-item :label-width="formLabelWidth" label="店铺名称" style="width:615px;">
							<el-input type="text" v-model="storeGoodsInfo.storeName" placeholder="请输入" disabled />
						</el-form-item>
						<el-form-item :label-width="formLabelWidth" label="供应商名称" style="width:310px;">
							<el-input type="text" v-model="storeGoodsInfo.supplierName" placeholder="请输入" disabled />
						</el-form-item>
					</div>

					<div style="display: flex;align-items: center;">
						<el-form-item :label-width="formLabelWidth" label="商品名称" style="width:615px;">
							<el-input type="text" clearable v-model="storeGoodsInfo.goodsName" placeholder="请输入商品名称"/>
						</el-form-item>
						<el-form-item :label-width="formLabelWidth" label="商品编号" style="width:310px;">
							<el-input type="text" clearable v-model="storeGoodsInfo.goodsCode" placeholder="请输入商品编号"/>
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;">
						<el-form-item :label-width="formLabelWidth" label="市场价" >
							<el-input type="text" oninput="value=value.replace(/[^0-9.]/g,'')"  width="50"
								v-model="storeGoodsInfo.marketPrice" placeholder="请输入数字" />
						</el-form-item>
						<el-form-item :label-width="formLabelWidth" label="零售价格" >
							<el-input type="text" oninput="value=value.replace(/[^0-9.]/g,'')" width="50"
								v-model="storeGoodsInfo.price" placeholder="请输入数字" />
						</el-form-item>
						<el-form-item :label-width="formLabelWidth" label="供货价格" >
							<el-input type="text" oninput="value=value.replace(/[^0-9.]/g,'')"  width="50"
								v-model="storeGoodsInfo.costPrice" placeholder="请输入数字" />
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;">
						<el-form-item :label-width="formLabelWidth" label="排序级别">
							<el-input type="text" oninput="value=value.replace(/[^0-9]/g,'')" width="50"
								v-model="storeGoodsInfo.orderIndex" placeholder="请输入数字(降序)" />
						</el-form-item>
						
						<el-form-item :label-width="formLabelWidth" label="销量">
							<el-input type="text" oninput="value=value.replace(/[^0-9]/g,'')"  width="50"
								v-model="storeGoodsInfo.salesSum" placeholder="请输入数字" />
						</el-form-item>
						<el-form-item :label-width="formLabelWidth" label="库存" >
							<el-input type="text" oninput="value=value.replace(/[^0-9]/g,'')"  width="50"
								v-model="storeGoodsInfo.stock" placeholder="请输入数字" />
						</el-form-item>
					</div>
					<!-- <div>
						<el-form-item :label-width="formLabelWidth" label="是否上架" style="width: 250px;">
							<el-switch v-model="status" :active-value="true" :inactive-value="false">
							</el-switch>
						</el-form-item>
					</div> -->
					<div style="display: flex;align-items: center;" >
						<el-form-item :label-width="formLabelWidth" label="是否上架" style="width:310px;">
							<el-switch v-model="status" :active-value="true" :inactive-value="false" style="margin-top:8px;">
							</el-switch>
						</el-form-item>
						<el-form-item  :label-width="formLabelWidth"  label="仅内部记账" style="width:320px;">
							<el-switch v-model="isShowOnline" :active-value="true" :inactive-value="false" style="margin-top:8px;">
							</el-switch>
							<span style="padding-left:10px;">(打开则不显示给会员查看)</span>
						</el-form-item>
						<el-form-item  :label-width="formLabelWidth"  label="显示位置" v-if="stoId != 0 && storeType==1">
							 <el-radio-group v-model="goodPlace" style="margin-top:10px;">
								<el-radio :label="1">商城</el-radio>
								<el-radio :label="2">门店</el-radio>
							</el-radio-group>
						</el-form-item>
						<!-- <div v-else style="width:30%"></div> -->
						<!-- <el-form-item  :label-width="formLabelWidth"  label="" v-else style="width:150px;border: 1px solid red">
						</el-form-item> -->
					</div>
					<div v-if="goodPlace==1">
						<!-- 商城商品 -->
						<div style="display: flex;align-items: center;justify-content: space-between;">
							<el-form-item :label-width="formLabelWidth" label="商品分类">
								<el-select clearable v-model="classGoods1Id" placeholder="请选择一级分类"
									style="width:200px;margin-right:10px;" @change="classGoods1">
									<el-option clearable v-for="item in classGoods1List" :key="item.id" :label="item.className"
										:value="item.id"></el-option>
								</el-select>
								<el-select clearable v-model="classGoods2Id" placeholder="请选择二级分类"
									style="width:200px;margin:  0px 10px;" @change="classGoods2">
									<el-option v-for="item in classGoods2List" :key="item.id" :label="item.className" :value="item.id">
									</el-option>
								</el-select>
								<el-select clearable v-model="classGoods3Id" placeholder="请选择三级分类"
									style="width:200px;margin:  0px 10px;" @change="classGoods3">
									<el-option v-for="item in classGoods3List" :key="item.id" :label="item.className" :value="item.id">
									</el-option>
								</el-select>
							</el-form-item>
						</div>
						<el-form-item  :label-width="formLabelWidth"  label="开启多规格" >
							<el-switch v-model="storeGoodsInfo.isGuige" :active-value="true" :inactive-value="false" style="margin-top:8px;">
							</el-switch>
						</el-form-item>
						<div v-if="storeGoodsInfo.isGuige==1" style="font-size: 28px;">规格</div>
						<div v-if="storeGoodsInfo.isGuige==1"
							style="display: flex;align-items: flex-start;flex-direction: column;margin: 20px 0;border: 1px solid;padding: 20px;">
							<div
								style="font-size: 18px;margin: 20px 0;display: flex;flex-direction: row;align-items: center;">
								<div>属性</div>
								<el-select clearable v-model="productAttributeCategoryId" placeholder="请选择商品类别"
									style="margin: 0 0px 0 20px;" size="mini" @change="selectClassGoods">
									<el-option clearable v-for="item in categoryList" :key="item.id" :label="item.name"
										:value="item.id"></el-option>
								</el-select>
							</div>
							<div v-for=" (item,index) in allPropertyList" style="display: flex;">
								<div>
								<p style="text-align: left;padding: 20px;font-size: 16px;">{{item.name}}:</p>
								<div>
									<el-checkbox-group  @change="sxchange($event,index,item)" v-model="item.checkboxGroupParameter" v-if="item.selectType==2&&item.inputList!=''">
										<el-checkbox :label="a" v-for="(a,b) in item.inputList.split(',')">											
											{{a}}
										</el-checkbox>
									</el-checkbox-group>									
									<el-checkbox-group  v-model="sxvalue" v-if="item.selectType!==2" :max="1">
										<el-checkbox :label="a" v-for="(a,b) in item.inputList.split(',')">
										</el-checkbox>
									</el-checkbox-group>
									<div style="margin: 10px;">
										<el-input v-if="item.handAddStatus==1" type="text" v-model="sxname" placeholder="请输入" style="float: left;width: 200px;" />										
										<el-button @click="addsx(item,index)" v-if="item.handAddStatus==1" style="float: left;">添加</el-button>
									</div>
								</div>
								</div>
							</div>
							
							<el-table :data="inputLists" style="width: 100%" ref="multipleTable"
								@selection-change="handleSelectionChange">
								<!-- <el-table-column type="selection" width="55">
								</el-table-column> -->
								<el-table-column v-for="(item,index) in allPropertyList" prop="guigeName" :label="item.name">
									<template slot-scope="scope">
										{{index==0?scope.row.guigeName.split(',')[0]:scope.row.guigeName.split(',')[1]}}
										<!-- <span v-if="item.guigeName">{{index==0?item.guigeName.split(',')[0]:item.guigeName.split(',')[1]}}</span> -->
									</template>
								</el-table-column>
								<el-table-column prop="stock" label="库存">
									<template slot-scope="scope">
										<el-input v-model="scope.row.stock" size="mini" type="text" placeholder="输入库存"
											oninput="value=value.replace(/[^0-9.]/g,'')" />
									</template>
								</el-table-column>
								<el-table-column prop="orderIndex" label="排序">
									<template slot-scope="scope">
										<el-input v-model="scope.row.orderIndex" size="mini" placeholder="输入排序" type="text"
											oninput="value=value.replace(/[^0-9.]/g,'')" />
									</template>
								</el-table-column>
								<el-table-column prop="price" label="供应价">
									<template slot-scope="scope">
										<el-input v-model="scope.row.costPrice" size="mini" placeholder="输入供应价" type="text"
											oninput="value=value.replace(/[^0-9.]/g,'')" />
									</template>
								</el-table-column>
								<el-table-column prop="price" label="销售价格">
									<template slot-scope="scope">
										<el-input v-model="scope.row.price" size="mini" placeholder="输入销售价格" type="text"
											oninput="value=value.replace(/[^0-9.]/g,'')" />
									</template>
								</el-table-column>
								<el-table-column prop="price" label="市场价">
									<template slot-scope="scope">
										<el-input v-model="scope.row.marketPrice" size="mini" placeholder="输入市场价"
											type="text" oninput="value=value.replace(/[^0-9.]/g,'')" />
									</template>
								</el-table-column>
								
								<!-- <el-table-column prop="rewardIntegralNumber" label="消费积分">
									<template slot-scope="scope">
										<el-input v-model="scope.row.rewardIntegralNumber" size="mini" placeholder="输入消费积分" type="text"
											oninput="value=value.replace(/[^0-9.]/g,'')" />
									</template>
								</el-table-column> -->
							</el-table>
							<div class=""
								style="display: flex;flex-direction: row;justify-content: space-between;align-items: center;width: 100%;">
								<el-button type="primary" style="align-self: flex-start;"
									v-if="selectProperty[0].handAddStatus==1" @click="addTable">自定义规格</el-button>
								<div v-else></div>
								<!-- <el-button type="primary" @click="saveData" style="align-self: flex-end;">保存</el-button> -->
							</div>
						</div>
						<div style="display: flex;align-items: center;">
							<!-- <el-form-item :label-width="formLabelWidth" label="赠送积分">
								<el-select clearable v-model="integral" placeholder="请选择赠送积分"
									style="width:200px;" @change="changeIntegral">
									<el-option v-for="item in integralList" :key="item.id" :label="item.name" :value="item.id">
									</el-option>
								</el-select>
							</el-form-item> -->
							<el-form-item label="发货方式" :label-width="formLabelWidth" style="width: 300px;">
								<el-select clearable v-model="storeGoodsInfo.expressType" placeholder="请选择发货方式"
									style="width:190px;">
									<el-option clearable label="快递" :value="1"></el-option>
									<el-option clearable label="自提" :value="2"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item :label-width="formLabelWidth" label="商品类别" v-if="isRecheck">
								<el-select clearable v-model="storeGoodsInfo.isShopFil" placeholder="请选择商品类别"
									style="width:190px;">
									<el-option clearable label="兑换" :value="14"></el-option>
									<el-option clearable label="共享" :value="16"></el-option>
									<el-option clearable label="活动" :value="17"></el-option>
									<el-option clearable label="开户区" :value="18"></el-option>
									<el-option clearable label="精选区" :value="19"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item :label-width="formLabelWidth" label="商品类别" v-else>
								<el-select clearable v-model="storeGoodsInfo.isShopFil" placeholder="请选择商品类别"
									style="width:200px;margin-right:10px;">
									<el-option clearable label="兑换" :value="14"></el-option>
									<el-option clearable label="共享" :value="16"></el-option>
									<el-option clearable label="活动" :value="17" disabled></el-option>
									<el-option clearable label="开户区" :value="18"></el-option>
									<el-option clearable label="精选区" :value="19"></el-option>
								</el-select>
							</el-form-item>
						</div>
						
						<el-form-item label="运费设置" :label-width="formLabelWidth" >
							<el-select clearable v-model="storeGoodsInfo.expressTemplateId" placeholder="请选择快递模板"
								style="width:190px;" @change="expressTemplateChangr">
								<el-option v-for="item in TemplateList" :key="item.id" :label="item.name" :value="item.id"
								>
								</el-option>
							</el-select>
							<el-button @click="looktemplate" v-if="expressTemplateFlage">查看模板</el-button>
						</el-form-item>
					
						<div style="display: flex;align-items: center;">
							<el-form-item :label-width="formLabelWidth" label="储备积分" v-if="storeGoodsInfo.isShopFil==17 && isRecheck">
								<el-input type="text" oninput="value=value.replace(/[^0-9.]/g,'')"  width="50"
								v-model="storeGoodsInfo.reservePoints" placeholder="请输入数字" />
							</el-form-item>
						</div>
						<div v-if="stoId == 0" style="display: flex;align-items: center;">
							<!-- 平台身份才能维护-->
							<el-form-item :label-width="formLabelWidth" label="云链选品" style="width: 300px;">
								<el-switch v-model="isCloud" :active-value="true" :inactive-value="false" style="margin-top:8px;">
								</el-switch>
							</el-form-item>
							<el-form-item :label-width="formLabelWidth" label="分销价" v-if="isCloud">
								<el-input type="text" oninput="value=value.replace(/[^0-9.]/g,'')" 
								v-model="storeGoodsInfo.agreementPrice" placeholder="请输入数字" />
							</el-form-item>
						</div>
						<div v-if="stoId == 0"  style="display: flex;align-items: center;">
							<el-form-item label-width="120px" label="是否可采购下单" >
								<el-switch v-model="openS2b" :active-value="true" :inactive-value="false"  style="margin-top:8px;">
								</el-switch>
							</el-form-item>
							<el-form-item :label-width="formLabelWidth" label="起采数量" v-if="openS2b">
								<el-input type="text" size="small" width="50"
								v-model="storeGoodsInfo.minCaigouNum" placeholder="请输入数字" />
							</el-form-item>
						</div>
						<div v-if="stoId == 0"  style="display: flex;align-items: center;">
							<el-form-item label-width="120px" label="活动区产品" >
								<el-switch v-model="isActivityArea" :active-value="true" :inactive-value="false"  style="margin-top:8px;">
								</el-switch>
							</el-form-item>
							<el-form-item label-width="250" label="活动区赠送倍数" style="margin-left: 20px;" v-if="isActivityArea">
								<el-input type="text" size="small" width="20px" style="width: 90px;"
								v-model="storeGoodsInfo.activityAreaMultiple" placeholder="请输入数字" />
								<span style="padding-left: 20px;">倍</span>
							</el-form-item>
						</div>
						
					</div>
					<div v-if="goodPlace==2">
						<!-- 门店商品 -->
						<div style="display: flex;align-items: center;j" >
							<el-form-item :label-width="formLabelWidth" label="商品分类" style="width: 310px;">
								<el-select clearable v-model="chainClassId" placeholder="请选择分类" @change="classGoods">
									<el-option v-for="item in classssgoods" :key="item.id" :label="item.className" :value="item.id">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item :label-width="formLabelWidth" label="让利比例" style="width: 310px;">
								<el-select clearable v-model="storeGoodsInfo.yieldProfits" placeholder="请选择让利比例" @change="changeIntegral">
									<el-option v-for="item in rlList" :key="item.id" :label="item.name" :value="item.proportion">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="取货方式" :label-width="formLabelWidth">
								<el-select clearable v-model="storeGoodsInfo.expressType" placeholder="请选择取货方式">
									<el-option clearable label="到店核销" :value="1"></el-option>
								</el-select>
							</el-form-item>
						</div>
						<div style="display: flex;align-items: center;">
							
							<el-form-item  label="限购数量" :label-width="formLabelWidth">
								<el-input type="number"
									v-model="storeGoodsInfo.limitedPurchaseQuantity" placeholder="请输入限购数量" />
							</el-form-item>
						</div>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item :label-width="formLabelWidth" label="商品图片"><br />
							<el-upload :action="httpUrl" list-type="picture-card" :on-preview="handlePictureCardPreview"
								:on-remove="handleRemove" :file-list="fileList" :show-file-list="true" :on-success="onSuccess">
								<i class="el-icon-plus"></i>
							</el-upload>
						</el-form-item>

					</div>
	
					<div>
						<div style="text-align: start;margin: 10px;">商品详情</div>
						<el-form-item>
							<div id="lpc-quill" class="quill" style="width: 100%; height:720px">
								<el-upload class="upload-demo" v-show="false" ref="upload" :action="httpUrl"
									:before-upload="beforeAvatarUpload" :on-success="upScuccess" :on-error="uploadError" />
								<quill-editor v-model="storeGoodsInfo.detail" ref="myQuillEditor" 
								class="editer" :options="editorOption" style="height:700px"
									@ready="onEditorReady($event)">
								</quill-editor>
							</div>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div style="text-align: center;margin-top:80px">
				<el-button v-if="dialogVisibleFunName == '新增商品'" type="primary" @click="add" :loading="addLoading">添 加</el-button>
				<el-button v-if="dialogVisibleFunName == '编辑商品'" type="primary" @click="sure" :loading="sureLoading">保 存</el-button>
				<el-button @click="dialogVisible = false">取 消</el-button>
			</div>
			
		</el-dialog>

		<!-- 错误提示 -->
		<el-dialog :visible.sync="dialogVisibleMistake" :closeOnClickModal="false" title="提示" width="50%">
			<div class="overflowBox" >
				{{ mistakeText }}
			</div>
			<div style="text-align: right;">
				<el-button type="primary" @click="dialogVisibleMistake = false">确 认</el-button>
			</div>
		</el-dialog>


		<el-dialog :visible.sync="dialogVisibleImg" :closeOnClickModal="false">
			<div style="text-align: center;">
				<img width="100%" class="el-upload-list__item-thumbnail" :src="dialogImageUrl" alt="">
			</div>
			<div style="text-align: center;">
				<el-button type="primary" @click="dialogVisibleImg = false">关 闭</el-button>
			</div>
		</el-dialog>

		<!-- 审核记录 -->
		<el-dialog style="float:rigin" title="审核记录" :closeOnClickModal="false" :visible.sync="auditFlag"
			width="70%">
			<div style="">
				<el-table :data="auditLogging.list" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="auditLoading"
					element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
					<el-table-column prop="id" label="ID" align="center" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="goodsName" label="商品名称" align="center" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="vertifyBy" label="审核人" align="center" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="remark" label="驳回原因" align="center" :show-overflow-tooltip="true">
						<template slot-scope="scope">
							<span v-if="scope.row.remark">{{ scope.row.remark }}</span>
							<span v-else>暂无</span>
						</template>
					</el-table-column>
					<el-table-column prop="fromDetail" label="审核前" align="center" :show-overflow-tooltip="true">
						<template slot-scope="scope">
							<el-button v-if="scope.row.fromDetail" size="small" type="text" @click="preAudit(scope.row.fromDetail)">点击查看</el-button>
							<span v-else>暂无</span>
						</template>
					</el-table-column>
					<el-table-column prop="toDetail" label="审核后" align="center" :show-overflow-tooltip="true">
						<template slot-scope="scope">
							<el-button v-if="scope.row.toDetail" size="small" type="text"  @click="afterAudit(scope.row.toDetail)">点击查看</el-button>
							<span v-else>暂无</span>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination style="margin: 20px 0px 20px;" background :current-page="auditLogging.pageNum"
					@current-change="auditPageChange" layout="total, sizes, prev, pager, next, jumper" :total="auditLogging.total"
					@size-change="auditHandleSizeChange">
				</el-pagination>
			</div>
			<div style="text-align: center;">
				<el-button @click="auditFlag=false;loading=false">关闭</el-button>
			</div>
		</el-dialog>


		<el-dialog style="height: 800px;float:rigin" title="模板详细" :closeOnClickModal="false" :visible.sync="templatevisible"
			width="50%">
			<el-table :data="Templatedetail" stripe style="width: 100%">
				
				<el-table-column prop="templateName" label="模板名称" align="center" width="" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="areaName" label="区域" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="feeType" label="计费方式" align="center" width="" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						{{scope.row.feeType==1?'按单':'按件'}}
					</template>
				</el-table-column>
				<el-table-column prop="fees" label="快递费" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				

				<el-table-column prop="updateTime" label="更新时间" align="center" width="" :show-overflow-tooltip="true">
				</el-table-column>
				<!-- <el-table-column prop="" label="操作" align="center" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<el-button size="small" type="text" @click="editialogVisible(scope.row)">编辑</el-button>
						<el-button size="small" type="text" @click="toDelete(scope.row.id)">删除</el-button>
						　　　　
					</template>
				</el-table-column> -->
			</el-table>
		</el-dialog>
		
		<!-- 审核前后 -->
		<el-dialog style="float:rigin" :title="auditTitle" :closeOnClickModal="false" :visible.sync="auditDialogVisibleInfo"
			width="50%">
			<div class="app-container" style="text-align: center;display: flex;width: 100%;justify-content: space-between;">
				<div>
					<el-form size="medium" >
						<div style="width: 100%;text-align: center;font-size: 22px;padding: 10px;">原信息</div>
						<div>
							<el-form-item label="店铺名称" style="width: 100%;">
								<el-input type="text" v-model="auditGoodsList.storeName" placeholder="请输入" disabled />
							</el-form-item>
						</div>
						<div>
							<el-form-item label="商品名称" style="width: 100%;">
								<el-input type="text" disabled clearable v-model="auditGoodsList.goodsName"
									placeholder="请输入商品名称" />
							</el-form-item>
							<el-form-item label="商品编号" style="width: 100%;">
								<el-input type="text" disabled clearable v-model="auditGoodsList.goodsCode"
									placeholder="请输入商品编号" />
							</el-form-item>
						</div>
						
						<div style="display: flex;align-items: center;">
							<el-form-item :label-width="formLabelWidth" label="市场价" >
								<el-input type="text" disabled size="small" width="50"
									v-model="auditGoodsList.marketPrice" placeholder="请输入数字" />
							</el-form-item>
							<el-form-item :label-width="formLabelWidth" label="零售价格" >
								<el-input type="text" disabled size="small" width="50"
									v-model="auditGoodsList.price" placeholder="请输入数字" />
							</el-form-item>
							<el-form-item :label-width="formLabelWidth" label="供货价格" >
								<el-input type="text" disabled size="small" width="50"
									v-model="auditGoodsList.costPrice" placeholder="请输入数字" />
							</el-form-item>
						</div>
						
						
						<div style="display: flex;align-items: center;justify-content: flex-start;">
							<el-form-item label="排序级别" class="redItem" >
								<span>{{auditGoodsList.orderIndex}}</span>
							</el-form-item>
							<el-form-item label="销量" class="redItem" style="margin-left: 30px;">
								<span>{{auditGoodsList.salesSum}}</span>
							</el-form-item>
							
							<el-form-item label="库存" class="redItem" style="margin-left: 30px;">
								<span>{{auditGoodsList.stock}}</span>
							</el-form-item>
						</div>
						<div v-if="auditGoodsList.goodsType == 1">
							<!-- 商城商品 -->
							<div style="display: flex;align-items: center;">
								<el-form-item label="发货方式" :label-width="formLabelWidth">
									<el-select disabled v-model="auditGoodsList.expressType" placeholder="请选择发货方式"
										style="width:200px;margin-right:10px;">
										<el-option clearable label="快递" :value="1"></el-option>
										<el-option clearable label="自提" :value="2"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item :label-width="formLabelWidth" label="商品类别" >
									<el-select disabled v-model="auditGoodsList.isShopFil" placeholder="请选择商品类别"
										style="width:200px;margin-right:10px;">
										<el-option clearable label="兑换" :value="14"></el-option>
										<el-option clearable label="共享" :value="16"></el-option>
										<el-option clearable label="活动" :value="17"></el-option>
									</el-select>
								</el-form-item>
							</div>
							<div style="display: flex;align-items: center;justify-content: space-between;">
								<el-form-item :label-width="formLabelWidth" label="是否上架" >
									<el-switch v-model="auditGoodsList.status" :active-value="true" :inactive-value="false" disabled>
									</el-switch>
								</el-form-item>
								<el-form-item label-width="300px" label="是否为活动区产品" >
									<el-switch v-model="auditGoodsList.isActivity" :active-value="true" :inactive-value="false" disabled>
									</el-switch>
								</el-form-item>
								<el-form-item :label-width="formLabelWidth" label="储备积分" v-if="auditGoodsList.isActivity&&stoId == 0 ">
									<el-input type="text" disabled size="small" width="50"
									v-model="auditGoodsList.reservePoints" placeholder="请输入数字" />
								</el-form-item>
							</div><div style="display: flex;align-items: center;">
								<el-form-item label="发货方式" :label-width="formLabelWidth">
									<el-select disabled v-model="auditGoodsList.expressType" placeholder="请选择发货方式"
										style="width:200px;margin-right:10px;">
										<el-option clearable label="快递" :value="1"></el-option>
										<el-option clearable label="自提" :value="2"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item :label-width="formLabelWidth" label="商品类别" >
									<el-select disabled v-model="auditGoodsList.isShopFil" placeholder="请选择商品类别"
										style="width:200px;margin-right:10px;">
										<el-option clearable label="兑换" :value="14"></el-option>
										<el-option clearable label="共享" :value="16"></el-option>
										<el-option clearable label="活动" :value="17"></el-option>
										<el-option clearable label="开户区" :value="18"></el-option>
										<el-option clearable label="精选区" :value="19"></el-option>
									</el-select>
								</el-form-item>
							</div>
							<div style="display: flex;align-items: center;justify-content: space-between;">
								<el-form-item :label-width="formLabelWidth" label="是否上架" >
									<el-switch v-model="auditGoodsList.status" :active-value="true" :inactive-value="false" disabled>
									</el-switch>
								</el-form-item>
								<el-form-item label-width="300px" label="是否为活动区产品" >
									<el-switch v-model="auditGoodsList.isActivity" :active-value="true" :inactive-value="false" disabled>
									</el-switch>
								</el-form-item>
								<el-form-item :label-width="formLabelWidth" label="储备积分" v-if="auditGoodsList.isActivity">
									<el-input type="text" disabled size="small" width="50"
									v-model="auditGoodsList.reservePoints" placeholder="请输入数字" />
								</el-form-item>
							</div>
						</div>
						<div v-if="auditGoodsList.goodsType == 2">
							<!-- 门店商品 -->
							<div style="display: flex;align-items: center;">
								<el-form-item label="取货方式" :label-width="formLabelWidth">
									<el-select disabled v-model="auditGoodsList.expressType" placeholder="请选择取货方式"
										style="width:200px;margin-right:10px;">
										<el-option clearable label="到店核销" :value="1"></el-option>
									
									</el-select>
								</el-form-item>
								
							</div>
							<div style="display: flex;align-items: center;justify-content: space-between;">
								<el-form-item :label-width="formLabelWidth" label="是否上架" >
									<el-switch v-model="auditGoodsList.status" :active-value="true" :inactive-value="false" disabled>
									</el-switch>
								</el-form-item>
								<el-form-item label-width="300px" label="是否为活动区产品" >
									<el-switch v-model="auditGoodsList.isActivity" :active-value="true" :inactive-value="false" disabled>
									</el-switch>
								</el-form-item>
								<el-form-item :label-width="formLabelWidth" label="储备积分" v-if="auditGoodsList.isActivity">
									<el-input type="text" disabled size="small" width="50"
									v-model="auditGoodsList.reservePoints" placeholder="请输入数字" />
								</el-form-item>
							</div>
						</div>
						
						<div style="display: flex;align-items: center;justify-content: space-between;
						flex-wrap:wrap">
							<el-form-item label="商品图片(1:1)" >
								<br />
								<div style="width: 100%;display: flex;align-items: initial;flex-wrap:wrap">
									<img v-for="(it,index) in auditGoodsList.images" :src="it" :key="index" @click="handlePictureCardPreview(it)"
									style="width:144px;height:144px;margin-right:10px;margin-bottom:10px">
								</div>
							</el-form-item>
						</div>
						<el-form-item label="商品详细描述">
							<el-button size="small" type="text" @click="findDetail(auditGoodsList.detail,1)">点击查看</el-button>
						</el-form-item>
						
					</el-form>
				</div>
			</div>
		</el-dialog>
	
		<el-dialog style="float:rigin" title="设置分成" :closeOnClickModal="false"
			:visible.sync="JobSharingdialogVisible" width="1050px">
			<div class="app-container" style="text-align: center;">
				<el-form size="medium">
					<el-form-item :label-width="formLabelWidth" label="商品名称" style="width:615px;">
						{{jobInfo.goodsName}}
					</el-form-item>
					<div style="display: flex;align-items: center;">
						<el-form-item  :label-width="formLabelWidth"  label="是否开启分成" >
							<el-switch v-model="jobInfo.isOpenShar" :active-value="true" :inactive-value="false" style="margin-top:8px;">
							</el-switch>
						</el-form-item>
						
					</div>
					<div v-if="jobInfo.isOpenShar">
						<el-table :data="inputListss" style="width: 100%" ref="multipleTable"
							@selection-change="handleSelectionChange">
							
							<el-table-column prop="name" label="岗位" width="150">
							
							</el-table-column>
							<el-table-column prop="jobLevelRewardListDots" label="级别">
								<template slot-scope="scope" >
									<el-table  v-if="scope.row.jobLevelRewardListDots.length>0" :data="scope.row.jobLevelRewardListDots" style="width: 100%" >
										<el-table-column prop="name" label="级别名称" >
										</el-table-column>
										<el-table-column prop="name" label="岗位分成比例(%)">
											
											<template slot-scope="scope">
												<div style="display: flex;align-items: center;"  >
														<el-input v-model="scope.row.rewardRate" style="width: 80px;" size="mini" placeholder="输入岗位分成比例(%)" type="text"
															@input="inputs(scope)" />
														<span style="padding-left: 10px;">%</span>
												</div>
												
											</template>
										</el-table-column>
										<el-table-column prop="rewardNum" label="岗位分成金额" >
											<template slot-scope="scope">
												<el-input v-model="scope.row.rewardNum"  size="mini" placeholder="输入岗位分成金额" type="text"
													 />
											</template>
										</el-table-column>
									</el-table>	
									<span v-else>暂无级别</span>
								</template>
							</el-table-column>
							<el-table-column prop="name" label="岗位分成比例(%)" width="200"  >
								<template slot-scope="scope">
									<div style="display: flex;align-items: center;"  v-if="scope.row.jobLevelRewardListDots.length==0">
											<el-input v-model="scope.row.rewardRate" @input="inputs(scope)" size="mini" placeholder="输入岗位分成比例(%)" type="text"
											oninput="value=value.replace(/[^0-9.]/g,'')" style="width: 80px;" />
											<span style="padding-left: 10px;">%</span>
									</div>
										
								</template>
							</el-table-column>
							<el-table-column prop="rewardNum" label="岗位分成金额"  width="200">
								<template slot-scope="scope">
									<el-input v-if="scope.row.jobLevelRewardListDots.length==0" v-model="scope.row.rewardNum"  size="mini" placeholder="输入岗位分成金额" type="text"
										 />
								</template>
							</el-table-column>
						
						</el-table>
					</div>
						<!-- 商城商品 -->
					
						
					
					
				
					
				</el-form>
			</div>
			<div style="text-align: center;margin-top:80px">
		
				<el-button  type="primary" @click="jobsure" :loading="sureLoadings">确 认</el-button>
				<el-button @click="JobSharingdialogVisible = false">取 消</el-button>
			</div>
			
		</el-dialog>
		
	</div>
</template>

<script>
	
	import {
		uploadFileServer
	} from "@/api/axios.js";
	var urls = uploadFileServer('storeGoods');
	import {
		quillEditor
	} from "vue-quill-editor"; //调用编辑器
	import "quill/dist/quill.core.css";
	import "quill/dist/quill.snow.css";
	import "quill/dist/quill.bubble.css";

	Array.prototype.remove = function (val) {
		var index = this.indexOf(val);
		if (index > -1) {
			this.splice(index, 1);
		}
	};

	export default {
		components: {
			//使用编辑器
			quillEditor
		},
		data() {
			return {
				Gg1:[],
				Gg2:[],
				categoryList: [],
				categoryList1: [],
				imageUrl: "",
				addParameter: "",
				Dialoading: false,
				sureLoadings:false,
				//属性列表
				selectList: [],
				//参数列表
				selectList1: [],
				
				//选择属性列表
				selectProperty: [{
					handAddStatus: 0
				}],
				//选择参数列表
				selectParameter: [{
					inputList: []
				}],
				paId: "",
				paId1: "",
				guigeCode:[],
				//属性多选
				checkboxGroup: [],
				//参数多选
				checkboxGroup1: [],
				//表格列表
				inputList: [],
				inputLists:[],
				//提交信息
				guigeInfo: {},
				multipleSelection: [],
				allPropertyList: [],
				allParameterList: [],
				// allPropertyList2: [],
				selectAddProperty: "",
				selectAddParameter: "",
				productAttributeCategoryId: "",
				productAttributeCategoryId1: "",
				buy: {
					goodId: null,
					goodsName: null,
					price: null,
					num: null,
					storeId: null,
					status: null,
					goodsImages: ""
				},
				formLabelWidth: '100px',
				setUpBuyVisible: false,
				goodsImages: [],
				fileList: [],
				TemplateList:[],
				dialogVisibleImg: false,
				dialogImageUrl: '',
				httpUrl: urls,
				loading: false,
				goodsList: [{}], //列表
				dialogVisible: false,
				editDialogVisible: false,
				dialogVisibleFunName: '',
				accountList: [],
				sxname:'',
				dialogVisibleDetails: false,
				detail: '',
				images: [],
				detailType: 0,

				classGoods1List: [],
				classGoods2List: [],
				classGoods3List: [],
				classGoods1Id: "",
				classGoods2Id: "",
				classGoods3Id: "",
				JobSharingdialogVisible:false,
				classGoods1Id1: '',
				classGoods2Id1: "",
				classGoods3Id1: "",
				ppId:[],

				status: false,
				isActivity: false,
				isCloud: false, //云链选品
				openS2b: false, //采购下单
				isActivityArea:false,//活动区
				storeGoodsInfo: { //新增或编辑数据
					classId: "",
					isGuige:false,
					expressType:1,
					isShopFil:14,
					expressTemplateId: ''
				},
				provinceList: {},
				cityList: {},
				districtList: {},
				storeGoodsId: '', //授权用户id
				form: {
					refuseReason: ""
				},
				mainFormRules: {
					refuseReason: {
						required: true,
						message: "请输入驳回原因",
						trigger: "blur"
					},
				},
				sxvalue:[],
				inputListss:[],
				page: {
					pageNum: 1,
					pageSize: 10
				},
				jobInfo:{},
				searchInfo: {
					authStatus: '',
					status: '',
					goodsType: null,
					isShowOnline: null,
					isShopFil: '',
				}, //表格查询数据
				editorOption: {
					// 富文本编辑器配置
					placeholder: "请输入内容",
					modules: {
						toolbar: {
							container: [
								["bold", "italic", "underline", "strike"], // 加粗，斜体，下划线，删除线
								[{
									header: 1,
								},
								{
									header: 2,
								},
								], // 标题，键值对的形式；1、2表示字体大小
								[{
									list: "ordered",
								},
								{
									list: "bullet",
								},
								], // 列表
								[{
									script: "sub",
								},
								{
									script: "super",
								},
								], // 上下标
								[{
									indent: "-1",
								},
								{
									indent: "+1",
								},
								], // 缩进
								[{
									direction: "rtl",
								},], // 文本方向
								[{
									size: ["small", false, "large", "huge"],
								},], // 字体大小
								[{
									color: [],
								},
								{
									background: [],
								},
								], // 字体颜色，字体背景颜色
								[{
									align: [],
								},], // 对齐方式
								["clean"], // 清除字体样式
								["image"], // 上传图片、上传视频
							],
							
							handlers: {
								image: function (value) {
									if (value) {
										document
											.querySelector("#lpc-quill .upload-demo input")
											.click();
									} else {
										this.quill.format("image", false);
									}
								},
							},

						},
					},
					theme: "snow",
				},

				integralList:[], //积分数据
				stoId: '', //用户ID
				storeNameId: '', //店铺iD
				supplierId: '', // 供应商id 
				selectStoreName: [],
				storeLoading: false,

				isRecheck: false, //是否可以审核
				userID: '', //登录用户ID

				auditGoodsInfo: {}, //商品审核前信息
				auditGoodsInfoTwo: {}, //商品审核后信息
				fileListL: [] , //商品审核前图片
				fileList1: [] , //商品审核后图片
				editDialogVisible1: false,
				reason: '', //驳回信息
				loadingTG: false,
				loadingBH: false,

				auditFlag:false, //审核记录弹窗
				auditLogging:{}, //审核记录
				auditPage: { //审核记录
					pageNum: 1,
					pageSize: 10,
				},
				auditLoading:false,
				auditTitle: '',
				auditDialogVisibleInfo: false,
				auditGoodsList: {},
				templatevisible:false,
				Templatedetail:[],

				sureLoading :false,
				addLoading : false,


				goodPlace: 1, //显示位置 1:商城   2:门店(storeType为1时才显示这个值的维护)
				storeType: 1, //店铺类型
				rlList:[], //让利
				isShowOnline: false,
				chainClassId:'',
				classssgoods:[],
				yieldProfits:'',


				dialogVisibleMistake: false,
				mistakeText: '',


				storeSupplierId: '',

				expressTemplateFlage: false,
			};
		},
		
		methods: {
			expressTemplateChangr(e){
				if(e != 0){
					this.expressTemplateFlage = true
				}else{
					this.expressTemplateFlage = false
				}
			},
			fllist(){
				this.$api.findClassList().then((res) => { //商品一级分类
					if (res.state == 'success') {
						this.classssgoods = res.data;
						// console.log('供应商---', res.data)
					}
				})
			},
			classGoods(e){
				this.storeGoodsInfo.chainClassId=e
			},
			looktemplate(){
				this.templatevisible=true
				this.$api.storeExpressfeeList({templateId:this.storeGoodsInfo.expressTemplateId}).then(res=>{
					this.Templatedetail=res.data.list
				})
			},
			sxchange(e,i,it){
				this.inputLists=[]
				
				let guigeName=[]
				if(i==0){
					this.ppId[0]=it.id
					this.guigeCode[0]=it.name
					this.Gg1=e
					
				}else{
					
					this.Gg2=e
					this.ppId[1]=it.id
					this.guigeCode[1]=it.name
				}
				// console.log(this.Gg2,this.Gg1);
				if(this.Gg1.length>0&&this.Gg2.length>0){
					this.Gg1.map(item=>{
						this.Gg2.map(items=>{
							this.inputLists.push({
								
								guigeName: item+','+items,
								stock: "",
								paId: this.ppId.join(','),
								guigeCode: this.guigeCode.join(','),
								rewardIntegralNumber: "",
								guigeImage: "",
								price: "",
								marketPrice: "",
								costPrice: "",
								orderIndex: "",
							});
						})
					})
				}
				if(this.Gg1.length>0&&this.Gg2==0){
					// console.log('01234');
					this.Gg1.map(item=>{
						this.inputLists.push({
							
							guigeName: item+','+'',
							stock: "",
							paId: this.ppId.join(','),
							guigeCode: this.guigeCode.join(','),
							rewardIntegralNumber: "",
							guigeImage: "",
							price: "",
							marketPrice: "",
							costPrice: "",
							orderIndex: "",
						});
					})
				}
				if(this.Gg2.length>0&&this.Gg1==0){
					// console.log('01234');
					this.Gg2.map(item=>{
						this.inputLists.push({
							
							guigeName: ''+','+item,
							stock: "",
							paId: this.ppId.join(','),
							guigeCode: this.guigeCode.join(','),
							rewardIntegralNumber: "",
							guigeImage: "",
							price: "",
							marketPrice: "",
							costPrice: "",
							orderIndex: "",
						});
					})
				}
				// console.log(this.allPropertyList);
				
			},
			addsx(it,ins){
				// console.log(this.allPropertyList.find(item=>item.id==it.id).inputList.split(','));
			let arr=this.allPropertyList.find(item=>item.id==it.id).inputList.split(',')
				arr.push(this.sxname)
			
				this.allPropertyList[ins].inputList=arr
				this.$set(this.allPropertyList[ins],'inputList',arr.join(','))
				this.sxname=''
				// console.log(this.allPropertyList);
			},
			checkButton(e) {
				this.checkboxGroup1 = [];
			},
			groupByName(groupData) {
				let result = groupData.reduce((prevValue, currentValue) => {
					let index = -1;
					prevValue.some((item, i) => {
						if (item.guigeCode == currentValue.guigeCode) {
							index = i;
							return true;
						};
					});
					if (index > -1) {
						prevValue[index].guigeTypes.push(currentValue.guigeType, );
					} else {
						prevValue.push({
							guigeCode: currentValue.guigeCode,
							guigeTypes: [currentValue.guigeType, ]
						});
					}
					return prevValue;
				}, []);
				return result;
			},
			jobsure(){
				this.$set(this.inputListss[0],'cardId',this.jobInfo.id)
				this.$set(this.inputListss[0],'type',2)
				this.$set(this.inputListss[0],'isOpenShar',this.jobInfo.isOpenShar)
				this.inputListss.map(item=>item.rewardRate=item.rewardRate/100)
				this.inputListss.map(item=>{
					item.jobLevelRewardListDots.map(item=>item.rewardRate=item.rewardRate/100)
				})
				this.$api.adderpCardJobRewards(this.inputListss).then(res=>{
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.sureLoadings=false
						this.hxdialogVisible=false
						this.JobSharingdialogVisible = false;
					} else {
						this.$message.error(res.message);
						this.sureLoadings=false
					}
				})
			},
			checkButton1(e) {
				let arr = [];
				this.selectList1.map((v, i) => {
					this.checkboxGroup1.map((a, b) => {
						if (v.name == a) {
							arr.push(v);
						};
					});
				});
				this.selectParameter = arr.map((item, index) => {
					return {
						name: item.name,
						id: item.id,
						checkboxGroupParameter: [],
						handAddStatus: item.handAddStatus,
						selectType: item.selectType,
						type: item.type,
						inputList: item.inputList.split(",").map((a, b) => {
							return {
								name: a
							}
						})
					}
				});
				this.selectParameter.map((v, i) => {
					let arr = v.inputList
					v.inputList.map((a, b) => {
						if (!a.name) {
							v.inputList.splice(b)
						}
					})
				})
				this.$forceUpdate();
			},
			
			selectClassGoods1() {
				this.selectAddParameter = ''
				this.allParameterList = []
				this.$api.goodsGuigeTypeList({
					goodsClassId: this.productAttributeCategoryId,
					type: '1'
				}).then((res) => {
					if (res.state == "success") {
						res.data.list.map((item, index) => {
							if (item.type == 1)
								this.allParameterList.push(item)
						})
					}
				})
			},
			addTable() {
				this.inputList.push({
					add: true,
					guigeName: "",
					stock: "",
					paId: this.paId,
					guigeCode: this.checkboxGroup[0],
					rebackNum: "",
					guigeImage: "",
					price: "",
					marketPrice: "",
					costPrice: "",
					orderIndex: "",
				});
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			saveData() {
				// console.log(this.inputLists);
				let data = {
					goodsGuiges: this.multipleSelection,
					guigeTypes: this.selectParameter.map((a, b) => {
						return {
							guigeTypes: a.checkboxGroupParameter,
							guigeCode: a.name,
							paId:a.id
						}
					})
				}
				let a = data.goodsGuiges.every((item, index) => {
					return item.rebackNum > 0
				})
				if (a) {
					this.guigeInfo = data;
					this.$message.success("保存成功");
					// console.log(this.guigeInfo);
			
				} else {
					this.$message("规格消费积分需大于0,请重新编辑");
					return
				}
			},
			inputs(a){
				
					a.row.rewardNum = (a.row.rewardRate * this.jobInfo.price*10000000/1000000000).toFixed(2)
				
				
			},
			addSelectAddProperty() {
				this.allPropertyList.map((item, index) => {
					if (item.id == this.selectAddProperty) {
						this.selectList.push(item)
					}
				})
				this.$message.success("添加成功");
				this.productAttributeCategoryId = ""
				this.selectAddProperty = ""
				this.allPropertyList = []
			},
			checkGroup(e) {
				// console.log(e,123456);
				console.log(this.selectList);
				let arr = [];
				this.paId = ""
				this.inputList = [];
				this.selectList.map((v, i) => {
					if (v.name == e[0]) {
						this.paId = v.id;
						// console.log(v,typeof v.inputList)
						if ((typeof v.inputList) == "string") {
							let arr1 = v.inputList.split(',')
							v.inputList = arr1
							let arr2=[]
							v.inputList.map((a, b) => {
								if (a) {
									arr2.push(a)
								}
							})
							arr = arr2;
						} else if ((typeof v.inputList) == "object") {
							arr = v.inputList;
						} else {
							this.$message.error("规格错误");
							arr = []
						}
						this.selectProperty[0] = v;
					}
				})
				arr.map((a, b) => {
					this.inputList.push({
						guigeName: a,
						stock: "",
						paId: this.paId,
						guigeCode: this.checkboxGroup[0],
						rebackNum: "",
						guigeImage: "",
						price: "",
						marketPrice: "",
						costPrice: "",
						orderIndex: "",
					});
				});
				
			},
			checkGroup1(e) {
				// console.log(this.selectList1,e,999);
				this.paId1 = ""
				this.selectList1.map((v, i) => {
					if (v.name == e[0]) {
						this.paId1 = v.id;
					}
				})
			
			},
			addParameterButton(item) {
				item.push({
					name: this.addParameter
				});
				this.addParameter = "";
				this.$forceUpdate();
			},
			
			
			addSelectAddProperty1() {
				this.allParameterList.map((item, index) => {
					if (item.id == this.selectAddParameter) {
						this.selectList1.push(item)
					}
				})
				this.$message.success("添加成功");
				this.productAttributeCategoryId1 = ""
				this.selectAddParameter = ""
				this.allParameterList = []
			},
			selectClassGoods() {
				this.selectAddProperty = ''
				this.allPropertyList = []
				this.$api.goodsGuigeTypeList({
					goodsClassId: this.productAttributeCategoryId,
					type: '0'
				}).then((res) => {
					if (res.state == "success") {
						// this.allPropertyList2 = res.data.list
						res.data.list.map((item, index) => {
							if (item.type == 0)
								this.allPropertyList.push({...item,checkboxGroupParameter: [],})
						})
					}
				})
			},
			// settingBuy() {
			// 	if (!this.buy.goodsImages) {
			// 		this.$message.error("请先设置商品图片");
			// 		return;
			// 	}
			// 	this.$api.GroupbuyGoodsInfo(this.buy).then((res) => {
			// 		if (res.state == 'success') {
			// 			this.setUpBuyVisible = false;
			// 			this.$message({
			// 				message: res.message,
			// 				type: 'success'
			// 			});
			// 		} else {
			// 			this.$message.error(res.message);
			// 		}
			// 	})

			// },
			preAudit(e){// 审核前
				// console.log('审核前---',JSON.parse(e))
				let data =JSON.parse(e);
				this.auditTitle = '审核前'
				// if(data){
					this.auditDialogVisibleInfo = true;
					this.auditGoodsList = data
					if(data.images){
						this.auditGoodsList.images = data.images.split(',')
					}
				// }else{
				// 	this.$message.error('新增商品审核前信息是空白的哦！');
				// }
			
				
			},
			afterAudit(e){// 审核后
				// console.log('审核后---',JSON.parse(e))
				let data =JSON.parse(e);
				this.auditTitle = '审核后'
				this.auditDialogVisibleInfo = true;
				this.auditGoodsList = data
				// this.auditGoodsList.images = data.images.split(',')
				if(data.images){
					this.auditGoodsList.images = data.images.split(',')
				}
				// console.log(this.auditGoodsList)
			},
			auditClick(item){
				// console.log('商品审核记录--',item)
				this.auditPage.goodsId = item.id
				this.auditPage.pageNum = 1;
				this.auditPage.pageSize = 10;
				this.getAuditLogging()
				this.auditFlag = true;
			},
			auditPageChange(data) { //审核记录
				this.auditPage.pageNum = data
				this.getAuditLogging()
			},
			auditHandleSizeChange(val) { //审核记录
				this.auditPage.pageSize = val
				this.getAuditLogging()
			},
			getAuditLogging(){ //查询审核记录
				this.auditLoading = true
				// console.log('审核记录---', this.auditPage)
				this.$api.findshenhgoods(this.auditPage).then((res) => { //商品列表
					// console.log(res);
					if (res.state == 'success') {
						this.auditLogging = res.data
						this.auditLoading = false
					}
				})
			},
			remoteMethod(query) {
				if (query.length >= 2) {
					this.storeLoading = true;
					setTimeout(() => {
						let data = {
							storeName: query,
						}
						this.$api.getStoreNameList(data).then((res) => { //店铺管理
							if (res.state == 'success') {
								this.selectStoreName = res.data;
							} else {
								this.$message.error(res.message);
							}
						})
						this.storeLoading = false;
					}, 200);
					} else {
						this.selectStoreName = [];
					}
			},
			searchStore(){
				let data = {
					storeName: '',
				}
				this.$api.getStoreNameList(data).then((res) => { //店铺管理
					if (res.state == 'success') {
						this.selectStoreName = res.data;
						// console.log('店铺管理---', res.data)
					} else {
						this.$message.error(res.message);
					}
				})
			},
			getStoreName(e) {
				// console.log(e);
				// this.supplierId = ''
				// this.storeNameId = e
				// console.log(this.selectStoreName);
				// console.log(e);
				let obj = {};
				obj = this.selectStoreName.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.storeGoodsInfo.storeName = obj.storeName;
				this.storeGoodsInfo.storeId = e;
				this.accountList = []
				if (e) {
					this.$api.supplierNameList({ 
						storeId: e
					}).then(res => {
						// res = JSON.parse(this.$decrypt(res.data))
						if (res.state == 'success') {
							this.accountList = res.data;

							if(this.supplierId != 0){
								// this.storeGoodsInfo.supplierId = this.accountList[0]
								this.storeSupplierId = this.accountList[0].id
								this.storeGoodsInfo.supplierId = this.accountList[0].id;
								this.storeGoodsInfo.supplierName = this.accountList[0].supplierName
							}else{
								this.storeSupplierId = ''
							}
						}
					})
				}

			},
			getSupplier(e){ //选择供应商
				// console.log('选择店铺--', e)
				let obj = {};
				obj = this.accountList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.storeGoodsInfo.supplierName = obj.supplierName;
				// this.storeGoodsInfo.supplierId = e;
				this.storeSupplierId = e;
			},
			setUpBuy(goodId, goodsName, storeId, image) {
				this.buy = {};
				this.setUpBuyVisible = true;
				this.buy.goodId = goodId;
				this.buy.goodsName = goodsName;
				this.buy.storeId = storeId;
				this.buy.price = 1000.00;
				this.buy.num = 1;
				this.buy.goodsImages = image.split(",")[0];
				this.dialogImageUrl = this.buy.goodsImages;
			},
			onSuccess(response, file, fileList) {
				// console.log(response);
				this.goodsImages.push(response.message);
			},
			handleRemove(file, fileList) {
				if (file.response) {
					this.goodsImages.remove(file.response.message);
				}
				this.goodsImages.remove(file.url);
			},
			handlePictureCardPreview(file) {
				// console.log(file);
				this.dialogImageUrl = file.url;
				this.dialogVisibleImg = true;
			},
			getStoreAndUser(e) {
				// console.log(e);
				let obj = {};
				obj = this.accountList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.storeGoodsInfo.username = obj.username;
				this.storeGoodsInfo.storeName = obj.storeName;
				this.storeGoodsInfo.userId = obj.userId;
			},
			
			findDetail(string, type) {
				this.dialogVisibleDetails = true;
				this.detailType = type;
				if (type == 1) {
					this.detail = string;

				}
				if (type == 2) {
					this.images = string.split(",");
				}
			},
			storeGoodsHitTheShelfOrSoldOut(id) {
				this.$api.storeGoodsHitTheShelfOrSoldOut(id).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.editDialogVisible = false
						this.getStoreGoodsList()
					} else {
						this.$message.error(res.message);
					}
				})
			},
			empty() {
				this.searchInfo = {}
			},
			search() {
				this.page.pageNum = 1;
				this.getStoreGoodsList()
			},
			//商品审核
			editStoreInfoCheck(authStatus) {
				if (authStatus == 2) {
					this.loadingBH = true;
					//驳回
					var data = {
						id: this.ids,
						status: 2,
						// status
						remark: this.reason
					}
				} else {
					this.loadingTG = true;
					//通过审核
					var data = {
						id: this.ids,
						status: 1
					}
				}
				this.$api.storeGoodsReview(data).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.editDialogVisible = false
						this.editDialogVisible1 = false
						this.reason = ''
						this.getStoreGoodsList()
					} else {
						this.$message.error(res.message);
					}
					this.loadingTG = false;
					this.loadingBH = false;
				})

			},
			bohui() {
				this.editDialogVisible1 = true
			},
			//审核驳回弹窗关闭
			cannelPass() {
				this.editDialogVisible = false
			},
			getClassName(id){
				let val = "";
				this.$api.findByGoodsClassId(id).then((res) => { //根据id查询商品分类
					if (res.state == 'success') {
						// console.log('第二及---', res.data)
						val = res.data.className
					}
				})
				return val;
			},
			//商品审核弹窗打开
			editialogVisible(id) {
				this.form.refuseReason = ""
				this.auditGoodsInfo = {};
				this.fileList = [];
				this.classGoods1Id = ""
				this.classGoods2Id = ""
				this.classGoods3Id = ""

				this.auditGoodsInfoTwo = {};
				this.classGoods1Id1 = ""
				this.classGoods2Id1 = ""
				this.classGoods3Id1 = ""
				this.fileList1 = [];
				
				this.$api.findshdetail(id).then((res) => {
					if (res.state == 'success') {
						// this.auditGoodsInfo = res.data
						// console.log('回显数据---', res.data)
						
						this.ids=res.data.id
						let res1=JSON.parse(res.data.fromDetail)
						let res2=JSON.parse(res.data.toDetail)

						// console.log('回显数据前---', res1)
						// console.log('回显数据后---', res2)
						
						if(res1!=null){
							this.auditGoodsInfo = res1

							// let str1 ={}
							// str1 = this.classGoods1List.find((item) => { //这里的userList就是上面遍历的数据源
							// 	return item.id === res1.classIdOne; //筛选出匹配数据
							// });
							// this.classGoods1Id = str1.className
							// this.$api.findByGoodsClassId(res1.classIdTwo).then((res) => { //根据id查询商品分类
							// 	if (res.state == 'success') {
							// 		this.classGoods2Id = res.data.className
							// 	}
							// })
							// this.$api.findByGoodsClassId(res1.classId).then((res) => { //根据id查询商品分类
							// 	if (res.state == 'success') {
							// 		// console.log('第二及---', res.data)
							// 		this.classGoods3Id = res.data.className
							// 	}
							// })

							let imagesArray = res1.images.split(",");
							
							for (let i = 0; i < imagesArray.length; i++) {
								this.fileList.push({
									name: imagesArray[i],
									url: imagesArray[i]
								})
							}
						}
						this.auditGoodsInfoTwo = res2
						if(res2.intermediatorUserId != 0 && res2.intermediatorUserId != null){
							this.auditGoodsInfoTwo.joint = res2.intermediatorUserId + '~' + res2.username + '~' +res2.phone 
						}

						// let str11 ={}
						// str11 = this.classGoods1List.find((item) => { //这里的userList就是上面遍历的数据源
						// 	return item.id === res1.classIdOne; //筛选出匹配数据
						// });
						// this.classGoods1Id1 = str11.className
						// this.$api.findByGoodsClassId(res1.classIdTwo).then((res) => { //根据id查询商品分类
						// 	if (res.state == 'success') {
						// 		this.classGoods2Id1 = res.data.className
						// 	}
						// })
						// this.$api.findByGoodsClassId(res1.classId).then((res) => { //根据id查询商品分类
						// 	if (res.state == 'success') {
						// 		// console.log('第二及---', res.data)
						// 		this.classGoods3Id1 = res.data.className
						// 	}
						// })
						// this.classGoods1Id1 = res2.c1
						// this.classGoods2Id1 = res2.c2
						// this.classGoods3Id1 = res2.c3
					
						let imagesArray1 = res2.images.split(",");
						for (let i = 0; i < imagesArray1.length; i++) {
							this.fileList1.push({
								name: imagesArray1[i],
								url: imagesArray1[i]
							})
						}
					}
				})
				this.storeGoodsId = id
				this.editDialogVisible = true;
			},
			//选中一级分类
			classGoods1(e) {
				this.classGoods2Id = "";
				this.classGoods3Id = "";
				this.classGoods3List = {};
				if (e) {
					// console.log(e)
					let obj = this.classGoods1List.find((item) => { //这里的userList就是上面遍历的数据源
						return item.id === e; //筛选出匹配数据
					});
					this.storeGoodsInfo.classNameOne = obj.className;
					this.$api.goodsClassfindByPid(e).then((res) => { //商品二级分类
						if (res.state == 'success') {
							this.classGoods2List = res.data;
						}
					})
				}
				this.selectList = [];
				this.selectList1 = [];
				this.selectParameter = [{
					inputList: []
				}];
				this.checkboxGroup = [];
				this.checkboxGroup1 = [];
				this.inputList = [];
				this.$api.findPmsAttributeRelationList({
					pid: this.classGoods1Id
				}).then((res) => { //商品列表
					if (res.state == 'success') {
						res.data.map((item, index) => {
							if (item.type == 0) {
								this.selectList.push(item);
							};
						});
						res.data.map((item, index) => {
							if (item.type == 1) {
								this.selectList1.push(item);
							};
						});
				
					};
				});
			},
			//选中二级分类
			classGoods2(e) {
				// console.log(e)
				this.classGoods3Id = "";
				this.classGoods3List = {};
				if (e) {
					let obj = this.classGoods2List.find((item) => { //这里的userList就是上面遍历的数据源
						return item.id === e; //筛选出匹配数据
					});
					this.storeGoodsInfo.classNameTwo = obj.className;

					this.$api.goodsClassfindByPid(e).then((res) => { //商品三级分类
						if (res.state == 'success') {
							this.classGoods3List = res.data;
						}
					})
				}
			},
			//选中三级分类
			classGoods3(e) {
				// console.log(e)
				let obj = {};
				obj = this.classGoods3List.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.storeGoodsInfo.className = obj.className;
				this.storeGoodsInfo.classId = obj.id;
				this.storeGoodsInfo.classIdOne = this.classGoods1Id;
				this.storeGoodsInfo.classIdTwo = this.classGoods2Id;
			},
			changeIntegral(e){
				// console.log('积分选择--',e)
			},
			storeGoodsJobSharing(it){
				console.log(it);
				this.jobInfo=it
				this.JobSharingdialogVisible=true
				this.$api.getJobList({cardId:it.id,type:2,storeId:it.storeId}).then(res=>{
					
					this.inputListss=res.data
					this.inputListss.map(item=>item.rewardRate=item.rewardRate*100)
					this.inputListss.map(item=>{
						item.jobLevelRewardListDots.map(item=>item.rewardRate=item.rewardRate*100)
					})
					
				})
			},
			// 店铺编辑弹窗
			dialogVisibleFun(id) {
				this.goodPlace = 1;
				// console.log('商品显示位置---', this.goodPlace)
				this.storeInfo = {}
				this.dialogVisibleFunName = "新增商品"
				this.dialogVisible = true;
				this.TemplateList=[{id:0,name:'包邮'}]
				this.storeGoodsInfo = {
					isGuige:false,
					expressTemplateId:0,
					expressType:1,
					// isShopFil:14
				};
				// this.storeGoodsInfo.yieldProfits = Number(8.4)
				this.storeGoodsInfo = {
					yieldProfits:this.yieldProfits
				};
				this.isShowOnline = false;
				this.chainClassId = "";
				this.storeGoodsInfo.isShopFil = 16; //商品类别
				this.storeGoodsInfo.expressType = 1; //发货方式
				this.goodsImages = [];
				this.fileList = [];
				this.classGoods2List = [];
				this.classGoods3List = [];
				this.classGoods1Id = "";
				this.classGoods2Id = "";
				this.classGoods3Id = "";
				this.checkboxGroup = [];
				this.checkboxGroup1 = [];
				this.inputList = [];
				this.storeGoodsId = "";
				this.paId = "";
				this.paId1 = "";
				this.guigeInfo = {};
				this.allPropertyList = [];
				this.allParameterList = [];
				// this.allPropertyList2 = [];
				this.selectAddProperty = "";
				this.selectAddParameter = "";
				this.productAttributeCategoryId="";
				this.productAttributeCategoryId1="";
				this.status = false;
				this.isActivity = false;
				this.isCloud = false;
				this.openS2b = false;
				this.isActivityArea=false
				this.selectList = [];
				this.selectList1 = [];
				this.selectParameter = [{
					inputList: []
				}];
				this.checkboxGroup = [];
				this.checkboxGroup1 = [];
				this.inputList = [];
				this.storeGoodsId = "";
				
				this.allPropertyList = [];
				this.allParameterList = [];
				// this.allPropertyList2 = [];
				this.selectAddProperty = "";
				this.selectAddParameter = "";
				
			
				if(this.stoId != 0){ //该用户有店铺，根据id查供应商
					this.$api.supplierNameList({ 
						storeId: this.stoId
					}).then(res => {
						// res = JSON.parse(this.$decrypt(res.data))
						if (res.state == 'success') {
							this.accountList = res.data;
							if(this.supplierId != 0){
								this.storeGoodsInfo.supplierId = this.accountList[0].id
								this.storeSupplierId = this.accountList[0].id
								this.storeGoodsInfo.supplierName = this.accountList[0].supplierName
							}else{
								this.storeSupplierId = ''
							}
						}
					})
				}else{
					this.searchStore(); //查询所有店铺
				}
				this.$api.findTemplateList(this.stoId).then(res=>{
					console.log(res);
					this.TemplateList=this.TemplateList.concat(res.data)
				})
				
				
				if (id) { 
					this.dialogVisibleFunName = "编辑商品"
					this.storeGoodsId = id
					this.$api.storeGoodsFindById(this.storeGoodsId).then((res) => {
						if (res.state == 'success') {
							this.storeGoodsInfo = res.data
							console.log('商品信息---', res.data)
							// this.$api.findTemplateList(res.data.storeId).then(res=>{
							// 	console.log(res,0); 
							// 		this.TemplateList=this.TemplateList.concat(res.data)
								
							// })
							this.status = this.storeGoodsInfo.status;
							this.isActivity = this.storeGoodsInfo.isActivity;
							this.isCloud = this.storeGoodsInfo.isCloud;
							this.openS2b = this.storeGoodsInfo.openS2b;
							this.isActivityArea = this.storeGoodsInfo.isActivityArea;
							
							this.productAttributeCategoryId=this.storeGoodsInfo.productAttributeCategoryId

							
							// goodsType 商品类别： 0=云连锁商品  1=商城商品  2=门店商品
							// goodPlace 显示位置： 1=商城  2=门店
							this.goodPlace = this.storeGoodsInfo.goodsType;
							
							this.isShowOnline = this.storeGoodsInfo.isShowOnline;

							this.chainClassId = res.data.offlineClassId;
							if(res.data.goodsType==2){
								this.$api.findChainGoodsClassList('/'+res.data.id).then((res) => { //商品一级分类
									if (res.state == 'success') {
										this.classssgoods = res.data;
									}
								})
							}
							this.inputLists=this.storeGoodsInfo.goodsGuiges
							// this.searchStore();
							 this.allPropertyList=this.storeGoodsInfo.allPropertyList;

							 this.storeSupplierId = this.storeGoodsInfo.supplierId
							if (res.data.classId) {
								this.$api.findByGoodsClassId(res.data.classId).then((res) => {
									if (res.state == 'success') {
										// console.log(123456789,res);
										if (res.data.level == 1) {
											this.classGoods1Id = res.data.id;
											let obj = {};
											obj = this.classGoods1List.find((item) => { //这里的userList就是上面遍历的数据源
												return item.id === this.classGoods1Id; //筛选出匹配数据
											});
											this.storeGoodsInfo.className = obj.className;
											
											
										} else if (res.data.level == 2) {
											this.classGoods2Id = res.data.id;
											this.$api.findByGoodsClassId(res.data.pid).then((res) => {
												if (res.state == 'success') {
													this.$api.goodsClassfindByPid(res.data.id).then((res) => { //商品二级分类
														if (res.state == 'success') {
															this.classGoods2List = res.data;

															let obj = {};
															obj = this.classGoods2List.find((item) => { //这里的userList就是上面遍历的数据源
																return item.id === this.classGoods2Id; //筛选出匹配数据
															});
															this.storeGoodsInfo.className = obj.className;
														}
													})
													this.classGoods1Id = res.data.id;
												} else {
													this.$message.error(res.message);
												}
											})
											
										} else if (res.data.level == 3) {
											this.classGoods3Id = res.data.id;
											this.$api.findByGoodsClassId(res.data.pid).then((res) => {
												if (res.state == 'success') {
													this.classGoods2Id = res.data.id;
													this.$api.goodsClassfindByPid(res.data.id).then((res) => { //商品三级分类
														if (res.state == 'success') {
															this.classGoods3List = res.data;

															let obj = {};
															obj = this.classGoods3List.find((item) => { //这里的userList就是上面遍历的数据源
																return item.id === this.classGoods3Id; //筛选出匹配数据
															});
															this.storeGoodsInfo.className = obj.className;
														}
													})
													this.$api.findByGoodsClassId(res.data.pid).then((res) => {
														if (res.state == 'success') {
															this.classGoods1Id = res.data.id;
															this.$api.goodsClassfindByPid(res.data.id).then((res) => { //商品二级分类
																if (res.state == 'success') {
																	this.classGoods2List = res.data;
																}
															})
														} else {
															this.$message.error(res.message);
														}
													})
												} else {
													this.$message.error(res.message);
												}
											})
										}
									} else {
										this.$message.error(res.message);
									}
								})
							}

							let imagesArray = res.data.images.split(",");
							this.goodsImages = imagesArray;
							for (let i = 0; i < imagesArray.length; i++) {
								if (imagesArray[i]) {
									this.fileList.push({
										name: imagesArray[i],
										url: imagesArray[i]
									})
								}
							}
						}
					})
				}
			},
			//添加商品
			add() {
				if(this.storeGoodsInfo.isGuige==1){
					if (this.inputLists) {
						if (this.inputLists) {
							this.storeGoodsInfo.goodsGuiges = this.inputLists;
							this.storeGoodsInfo.allPropertyList = this.allPropertyList;
							
						} else {
							// this.$message("暂无规格,请填写规格保存");
							this.mistakeText = '暂无规格,请填写规格保存!';
							this.dialogVisibleMistake = true;
							return
						}
						
					}
					this.inputLists.map((item,index)=>{
						if(!item.costPrice){
							// this.$message("保存规格供应价失败");
							this.mistakeText = "保存规格供应价失败";
							this.dialogVisibleMistake = true;
							return
						}
						if(!item.guigeCode){
							// this.$message("保存规格名称失败");
							this.mistakeText = "保存规格名称失败";
							this.dialogVisibleMistake = true;
							return
						}
						if(!item.guigeName){
							// this.$message("保存规格名称元素失败");
							this.mistakeText = "保存规格名称元素失败";
							this.dialogVisibleMistake = true;
							return
						}
						if(!item.marketPrice){
							// this.$message("保存规格市场价失败");
							this.mistakeText = "保存规格市场价失败";
							this.dialogVisibleMistake = true;
							return
						}
						if(!item.paId){
							// this.$message("保存规格ID失败");
							this.mistakeText = "保存规格ID失败";
							this.dialogVisibleMistake = true;
							return
						}
						if(!item.price){
							// this.$message("保存规格价格失败");
							this.mistakeText = "保存规格价格失败";
							this.dialogVisibleMistake = true;
							return
						}
						
						// if(!item.stock){
						// 	this.$message("保存规格库存失败");
						// 	return
						// }
					})
					//  console.log(this.storeGoodsInfo)
				}else{
					
				}
				
				if(this.storeGoodsInfo.agreementPrice >= this.storeGoodsInfo.price){
					// this.$message.error('分销价不能大于等于零售价!');
					this.mistakeText = "分销价不能大于等于零售价!";
					this.dialogVisibleMistake = true;
					return
				}
				if(this.goodPlace==1){
					if (!this.storeGoodsInfo.classId) {
						// console.log('1334')
						if (this.classGoods2Id) {
							this.storeGoodsInfo.classId = this.classGoods2Id;
							let obj = {};
							obj = this.classGoods2List.find((item) => { //这里的userList就是上面遍历的数据源
								return item.id === this.classGoods2Id; //筛选出匹配数据
							});
							this.storeGoodsInfo.className = obj.className;
						} else {
							this.storeGoodsInfo.classId = this.classGoods1Id;
							let obj = {};
							obj = this.classGoods1List.find((item) => { //这里的userList就是上面遍历的数据源
								return item.id === this.classGoods1Id; //筛选出匹配数据
							});
							this.storeGoodsInfo.className = obj.className;
						}
					}
				}
				if(this.stoId != 0){
					this.storeGoodsInfo.storeId = this.stoId
				}

				this.storeGoodsInfo.supplierId = this.storeSupplierId;

				this.addLoading = true;
				// this.storeGoodsInfo.classNameAll = classNameAll
				this.storeGoodsInfo.status = this.status;
				this.storeGoodsInfo.isActivity = this.isActivity;
				this.storeGoodsInfo.isCloud = this.isCloud;
				this.storeGoodsInfo.openS2b = this.openS2b;
				this.storeGoodsInfo.isActivityArea = this.isActivityArea;
				
				this.storeGoodsInfo.productAttributeCategoryId=this.productAttributeCategoryId
				this.storeGoodsInfo.images = this.goodsImages.toString();
				this.storeGoodsInfo.isShowOnline=this.isShowOnline
				// console.log('添加商品数据---',this.storeGoodsInfo)

				// goodsType 商品类别： 0=云连锁商品  1=商城商品  2=门店商品
				// goodPlace 显示位置： 1=商城  2=门店
				this.storeGoodsInfo.goodsType = this.goodPlace
				if(this.goodPlace==2){
					this.storeGoodsInfo.isGuige = 0;
					this.storeGoodsInfo.offlineClassId = this.chainClassId;
				}
				this.storeGoodsInfo.isShowOnline = this.isShowOnline ;
				this.$api.addStoreGoods({...this.storeGoodsInfo}).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.getStoreGoodsList();
						this.dialogVisible = false;
					} else {
						// this.$message.error(res.message);
						this.mistakeText = res.message;
						this.dialogVisibleMistake = true;
					}
					this.addLoading = false;
				})
			},
			//编辑商品
			sure() {
				if(this.storeGoodsInfo.isGuige==1){
					if (this.inputLists) {
						if (this.inputLists) {
							this.storeGoodsInfo.goodsGuiges = this.inputLists;
							this.storeGoodsInfo.allPropertyList = this.allPropertyList;
							
						} else {
							// this.$message("暂无规格,请填写规格保存");
							this.mistakeText = '暂无规格,请填写规格保存!';
							this.dialogVisibleMistake = true;
							return
						}
						
					}
					this.inputLists.map((item,index)=>{
						if(!item.costPrice){
							// this.$message("保存规格供应价失败");
							this.mistakeText = '保存规格供应价失败!';
							this.dialogVisibleMistake = true;
							return
						}
						if(!item.guigeCode){
							// this.$message("保存规格名称失败");
							this.mistakeText = '保存规格名称失败!';
							this.dialogVisibleMistake = true;
							return
						}
						if(!item.guigeName){
							// this.$message("保存规格名称元素失败");
							this.mistakeText = '保存规格名称元素失败!';
							this.dialogVisibleMistake = true;
							return
						}
						if(!item.marketPrice){
							// this.$message("保存规格市场价失败");
							this.mistakeText = '保存规格市场价失败!';
							this.dialogVisibleMistake = true;
							return
						}
						if(!item.paId){
							// this.$message("保存规格ID失败");
							this.mistakeText = '保存规格ID失败!';
							this.dialogVisibleMistake = true;
							return
						}
						if(!item.price){
							// this.$message("保存规格价格失败");
							this.mistakeText = '保存规格价格失败!';
							this.dialogVisibleMistake = true;
							return
						}
						
						// if(!item.stock){
						// 	this.$message("保存规格库存失败");
						// 	return
						// }
					})
					//  console.log(this.storeGoodsInfo)
				}else{
					
				}
				
				// console.log(this.storeGoodsInfo);
				if(this.storeGoodsInfo.agreementPrice >= this.storeGoodsInfo.price){
					// this.$message.error('分销价不能大于等于零售价!');
					this.mistakeText = '分销价不能大于等于零售价!';
					this.dialogVisibleMistake = true;
					return
				}
				if(this.goodPlace==1){
					if (!this.storeGoodsInfo.classId) {
						if (this.classGoods2Id) {
							this.storeGoodsInfo.classId = this.classGoods2Id;
							let obj = {};
							obj = this.classGoods2List.find((item) => { //这里的userList就是上面遍历的数据源
								return item.id === this.classGoods2Id; //筛选出匹配数据
							});
							this.storeGoodsInfo.className = obj.className;
						} else {
							this.storeGoodsInfo.classId = this.classGoods1Id;
							let obj = {};
							obj = this.classGoods1List.find((item) => { //这里的userList就是上面遍历的数据源
								return item.id === this.classGoods1Id; //筛选出匹配数据
							});
							this.storeGoodsInfo.className = obj.className;
						}
					} else {
						this.storeGoodsInfo.classIdOne = this.classGoods1Id;
						this.storeGoodsInfo.classIdTwo = this.classGoods2Id;
					}
				}
				if(this.stoId != 0){
					this.storeGoodsInfo.storeId = this.stoId
				}

				this.storeGoodsInfo.supplierId = this.storeSupplierId;

				this.sureLoading = true;
				this.storeGoodsInfo.status = this.status;
				this.storeGoodsInfo.isActivity = this.isActivity;
				this.storeGoodsInfo.isCloud = this.isCloud; 
				this.storeGoodsInfo.openS2b = this.openS2b; 
				this.storeGoodsInfo.isActivityArea = this.isActivityArea;
				
				this.storeGoodsInfo.productAttributeCategoryId = this.productAttributeCategoryId;
				this.storeGoodsInfo.isShowOnline=this.isShowOnline
				this.storeGoodsInfo.images = this.goodsImages.toString();
				// console.log('编辑商品数据---',this.storeGoodsInfo)

				// goodsType 商品类别： 0=云连锁商品  1=商城商品  2=门店商品
				// goodPlace 显示位置： 1=商城  2=门店

				this.storeGoodsInfo.goodsType = this.goodPlace
				if(this.goodPlace==2){
					this.storeGoodsInfo.isGuige = 0;
					this.storeGoodsInfo.offlineClassId = this.chainClassId;
				}
				this.storeGoodsInfo.isShowOnline = this.isShowOnline ;
				this.$api.editStoreGoods(this.storeGoodsInfo).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogVisible = false;
						this.getStoreGoodsList();
					} else {
						// this.$message.error(res.message);
						this.mistakeText = res.message;
						this.dialogVisibleMistake = true;
					}
					this.sureLoading = false;
				})

			},
			//删除
			toDelete(row) {
				/* if (row.status == 0) {
					var str = "此操作将启用该店铺账号, 是否继续?"
				} else {
					var str = "此操作将禁用该店铺账号, 是否继续?"
				} */
				var str = "此操作将删除该商品, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.delStoreGoods(row.id).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.getStoreGoodsList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			pageChange(data) {
				this.page.pageNum = data
				this.getStoreGoodsList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getStoreGoodsList()
			},
			getStoreGoodsList() {
				this.loading = true
				/* let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					storeName: this.searchInfo.storeName,
					goodsName: this.searchInfo.goodsName,
					status: this.searchInfo.status,
					authStatus: this.searchInfo.authStatus,
					goodsCode: this.searchInfo.goodsName
				} */
				// this.searchInfo.storeId = 47;
				this.searchInfo.pageNum = this.page.pageNum;
				this.searchInfo.pageSize = this.page.pageSize;
				this.$api.getStoreGoodsList(this.searchInfo).then((res) => { //商品列表
					if (res.state == 'success') {
						this.goodsList = res.data
						this.loading = false
					}
				})
			},
			changeNull(row, column, cellValue) {
				if (cellValue) {
					return cellValue;
				} else if (cellValue == 0) {
					return "0";
				} else {
					return "暂无";
				}
			},
			//上传店铺logo
			upLoadLogo(param) {
				const formData = new FormData()
				formData.append('file', param.file)
				this.$api.uploadFile(formData, "goods").then((res) => {
					// console.log('列表:', res);
					this.storeInfo.storeLogo = res.message
				})
			},
			// 上传身份证正面图片
			upLoadLegalIdFace(param) {
				const formData = new FormData()
				formData.append('file', param.file)
				this.$api.uploadFile(formData, "goods").then((res) => {
					this.storeInfo.legalIdFace = res.message
				})
			},
			// 上传身份证反面图片
			upLoadLegalIdBack(param) {
				const formData = new FormData()
				formData.append('file', param.file)
				this.$api.uploadFile(formData, "goods").then((res) => {
					// console.log('列表:', res);
					this.storeInfo.legalIdBack = res.message
				})
			},

			// 点击文件触发
			handlePreview(file) {
				// console.log(file)
			},
			// 上传图片前，筛选
			beforeAvatarUpload(file) {
				// console.log(file)1048576
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!');
					return false;
				}
				var imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/;
				if (!imgStr.test(file.name)) {
					this.$message.error("文件不是图片类型，请上传正确格式图片！");
					return false;
				}
				return isLt2M, imgStr;
			},
			upScuccess(res, file) {
				const quill = this.$refs.myQuillEditor.quill;
				if (res.state == "success" && res.data !== null) {
					const length = quill.getSelection().index; // 获取光标所在位置
					quill.insertEmbed(length, "image", res.message); // 插入图片
					quill.setSelection(length + 1); // 调整光标位置到最后
				} else {
					this.$message.error("图片上传失败");
				}
			},
			uploadError() {
				this.$message.error("图片上传失败");
			},
			onEditorReady(editor) {
				// 准备编辑器
				// console.log(editor);
			},

			getIsRecheck(id){
				// 查询可以审核商品的ID
				this.$api.byKey({key:'SYS_GOODS_CHECK'}).then(res=>{ 
					res=JSON.parse(this.$decrypt(res.data))
					if(res.state == 'success'){
						// console.log(res);
						let arr = (res.data.settingValue.split(','))
						this.isRecheck = arr.some(item => {
							return item == id
						})
						// console.log('登录人ID---',id)
						// console.log('数据---',arr)
						// console.log('是否可审核---',this.isRecheck)
					}
				})
			},
			logInUserInfo(){ //查询登录人信息
				this.$api.getUserInfo(this.$encrypt({})).then(res => {
					res.data = JSON.parse(this.$decrypt(res.data)).data
					if (res.state == 'success') {
						// console.log('登录人信息---', res.data )
						// supplierId(有值就是供应商)
						this.stoId = res.data.storeId; // storeId：0(平台)   
						this.userID = res.data.id
						this.supplierId = res.data.supplierId;
						this.getIsRecheck(res.data.id)
						if(res.data.storeId==0){
							// this.goodPlace = 1;
						}else{
							this.getstoreType(res.data.storeId)
						}
						
					}
				})
				
				
			},
			getstoreType(id){
				this.$api.getStoreId(id).then((res) => {
					res.data=JSON.parse(this.$decrypt(res.data)).data
					if (res.state == 'success') {
						// console.log('店铺信息--', res.data)
						this.storeType = res.data.storeType
						// if(res.data.storeType = 0){
						// 	this.goodPlace = 1;
						// }
						
						// this.yieldProfits=res.data.yieldProfits
						this.yieldProfits = 0.84
					}
				})
			}
		},
		created() {
			this.getStoreGoodsList();
			this.$api.goodsClassfindByPid(0).then((res) => { //商品一级分类
				if (res.state == 'success') {
					this.classGoods1List = res.data;
				}
			})
			this.$api.getIntegralList().then((res) => { //查询积分
				if (res.state == 'success') {
					// console.log('积分数据---',res.data)
					this.integralList = res.data;
				}
			})
			this.$api.pmsProductAttributeCategoryList({}).then((res) => { //商品一级分类
				if (res.state == 'success') {
					this.categoryList = res.data.list;
					this.categoryList1 = res.data.list;
				}
			})
			// this.$api.getUserInfo(this.$encrypt({})).then(res => {
			// 	res.data = JSON.parse(this.$decrypt(res.data)).data
			// 	if (res.state == 'success') {
			// 		// console.log('用户信息--', res.data)
			// 		this.stoId = res.data.storeId
			// 	}
			// })


			this.logInUserInfo();

			this.$api.storeProportionType().then(res=>{
				this.rlList=res.data
			})

			this.fllist()
		}

	};
</script>

<style scoped lang="less">
	/* 富文本 */
	/deep/ .ql-toolbar {
		width: 100%;
		text-align: left;
	}
	/deep/.ql-editor {
		height: 648px;
	}

	.demo-table-expand {
		font-size: 0;
		margin-left: 90px;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		width: 100px;
		height: 100px;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader1 .el-upload {
		border: 1px dashed #d9d9d9;
		width: 200px;
		height: 100px;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 100px;
		height: 100px;
		line-height: 100px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	.detailImg img {
		width: 100%;
	}

	.overflowBox{
		text-align: center;
		margin-bottom:40px;
		font-size:18px;
		color:#fa3534;
		max-height:300px;
		overflow-y: scroll;
	}
	.overflowBox::-webkit-scrollbar {
		display: none;
	}
</style>